import { useState, useEffect, useRef, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import BackButton from "../components/BackButton";
import {
  collection, query, where, onSnapshot, orderBy,
  doc, updateDoc, addDoc, deleteDoc, serverTimestamp, Timestamp, setDoc, writeBatch,
} from "firebase/firestore";
import { httpsCallable } from "firebase/functions";
import { auth, db, functions } from "../firebase";
import { signOut } from "firebase/auth";
import { playNotifSound } from "../utils/notifSound";
import Icon from "../components/Icon";

// ── Cloud Functions ที่แอดมินใช้ (เงินย้ายมาฝั่ง server ทั้งหมดแล้ว) ────────
const escrowReleaseFn  = httpsCallable(functions, "escrowRelease");
const escrowRefundFn   = httpsCallable(functions, "escrowRefund");
const topupApproveFn   = httpsCallable(functions, "topupApprove");
const topupRejectFn    = httpsCallable(functions, "topupReject");
const withdrawApproveFn = httpsCallable(functions, "withdrawApprove");
const withdrawRejectFn  = httpsCallable(functions, "withdrawReject");

const css = `
  .admin-page { font-family:'Prompt',sans-serif;background:#f5f6f8;color:#242b36;min-height:100vh;display:flex; }
  .admin-nav { width:220px;background:#ffffff;border-right:1px solid rgba(247,71,53,0.1);display:flex;flex-direction:column;flex-shrink:0;position:sticky;top:0;height:100vh;overflow-y:auto; }
  .nav-logo { padding:24px 20px 20px;border-bottom:1px solid rgba(247,71,53,0.1); }
  .nav-logo .logo { display:flex;align-items:center; }
  .nav-logo .logo span { color:#242b36; }
  .nav-logo-img { height:80px;width:auto;mix-blend-mode:screen;filter:brightness(1.1); }
  .admin-badge { font-size:0.65rem;color:#8a919e;letter-spacing:2px;text-transform:uppercase;margin-top:2px; }
  .nav-section { padding:16px 12px 8px; }
  .nav-section-label { font-size:0.62rem;letter-spacing:2px;text-transform:uppercase;color:#8a919e;padding:0 8px;margin-bottom:6px; }
  .nav-item { display:flex;align-items:center;gap:10px;padding:9px 12px;border-radius:10px;color:#8a919e;cursor:pointer;font-size:0.82rem;transition:all 0.2s;margin-bottom:2px;border:none;background:transparent;width:100%;text-align:left;font-family:'Prompt',sans-serif; }
  .nav-item:hover { background:#f4f5f7;color:#242b36; }
  .nav-item.active { background:rgba(247,71,53,0.1);color:#dc3728;border:1px solid rgba(247,71,53,0.15); }
  .nav-item .icon { font-size:1rem;width:20px;text-align:center; }
  .nav-badge { margin-left:auto;background:#ff5555;color:#fff;font-size:0.6rem;padding:1px 6px;border-radius:100px;font-weight:600; }
  .nav-badge.warning { background:#c77b27;color:#000; }
  .admin-main { flex:1;display:flex;flex-direction:column;overflow:hidden; }
  .admin-topbar { display:flex;align-items:center;justify-content:space-between;padding:16px 28px;background:#ffffff;border-bottom:1px solid rgba(247,71,53,0.1);flex-shrink:0; }
  .page-title { font-size:1.1rem;font-weight:600; }
  .page-subtitle { font-size:0.75rem;color:#8a919e;margin-top:2px; }
  .topbar-actions { display:flex;gap:10px;align-items:center; }
  .tb-btn { padding:8px 16px;border-radius:10px;border:1px solid rgba(247,71,53,0.2);background:transparent;color:#8a919e;font-size:0.8rem;cursor:pointer;font-family:'Prompt',sans-serif;transition:all 0.2s; }
  .tb-btn:hover { border-color:#dc3728;color:#dc3728; }
  .tb-btn.primary { background:#dc3728;color:#f5f6f8;border-color:#dc3728;font-weight:600; }
  .admin-content { flex:1;overflow-y:auto;padding:24px 28px; }
  .stats-grid { display:grid;grid-template-columns:repeat(4,1fr);gap:16px;margin-bottom:24px; }
  .stat-card { background:#ffffff;border:1px solid rgba(247,71,53,0.1);border-radius:12px;padding:20px;position:relative;overflow:hidden; }
  .stat-card.warning { border-color:rgba(255,179,71,0.2); }
  .stat-card.danger  { border-color:rgba(255,85,85,0.2); }
  .stat-card.info    { border-color:rgba(85,153,255,0.2); }
  .stat-label { font-size:0.72rem;color:#8a919e;letter-spacing:1px;text-transform:uppercase;margin-bottom:8px; }
  .stat-num { font-family:'DM Serif Display',serif;font-size:2rem;margin-bottom:4px; }
  .stat-card:not(.warning):not(.danger):not(.info) .stat-num { color:#dc3728; }
  .stat-card.warning .stat-num { color:#c77b27; }
  .stat-card.danger  .stat-num { color:#ff5555; }
  .stat-card.info    .stat-num { color:#5599ff; }
  .stat-change { font-size:0.72rem;color:#8a919e; }
  .stat-change.up { color:#dc3728; }
  .stat-change.down { color:#ff5555; }
  .table-card { background:#ffffff;border:1px solid rgba(247,71,53,0.1);border-radius:12px;margin-bottom:20px;overflow-x:auto; }
  .table-header { display:flex;justify-content:space-between;align-items:center;padding:16px 20px;border-bottom:1px solid rgba(247,71,53,0.08);flex-wrap:wrap;gap:8px; }
  .table-title { font-size:0.9rem;font-weight:600; }
  .table-actions { display:flex;gap:8px;flex-wrap:wrap; }
  .t-action { padding:6px 12px;border-radius:8px;border:1px solid rgba(247,71,53,0.15);background:transparent;color:#8a919e;font-size:0.75rem;cursor:pointer;font-family:'Prompt',sans-serif;transition:all 0.2s;white-space:nowrap; }
  .t-action:hover { border-color:#dc3728;color:#dc3728; }
  .data-table { width:100%;border-collapse:collapse;min-width:520px; }
  .data-table th { padding:10px 20px;font-size:0.68rem;letter-spacing:1.5px;text-transform:uppercase;color:#8a919e;text-align:left;background:#f4f5f7;border-bottom:1px solid rgba(247,71,53,0.08); }
  .data-table td { padding:12px 20px;font-size:0.82rem;border-bottom:1px solid rgba(247,71,53,0.05); }
  .data-table tr:last-child td { border-bottom:none; }
  .data-table tr:hover td { background:rgba(247,71,53,0.02); }
  .deal-id { font-family:'DM Mono','monospace';font-size:0.75rem;color:#dc3728; }
  .badge { display:inline-flex;align-items:center;gap:5px;padding:3px 10px;border-radius:100px;font-size:0.68rem;font-weight:500; }
  .badge.waiting  { background:rgba(255,179,71,0.1);color:#c77b27;border:1px solid rgba(255,179,71,0.2); }
  .badge.shipping { background:rgba(85,153,255,0.1);color:#5599ff;border:1px solid rgba(85,153,255,0.2); }
  .badge.success  { background:rgba(247,71,53,0.1);color:#dc3728;border:1px solid rgba(247,71,53,0.2); }
  .badge.dispute  { background:rgba(255,85,85,0.1);color:#ff5555;border:1px solid rgba(255,85,85,0.2); }
  .badge.pending  { background:rgba(255,179,71,0.1);color:#c77b27;border:1px solid rgba(255,179,71,0.2); }
  .badge-dot-sm { width:5px;height:5px;border-radius:50%;background:currentColor;animation:pulse 2s infinite;display:inline-block; }
  .action-link { color:#dc3728;background:none;border:none;cursor:pointer;font-size:0.78rem;font-family:'Prompt',sans-serif;text-decoration:none;padding:4px 8px;border-radius:6px;transition:background 0.2s; }
  .action-link:hover { background:rgba(247,71,53,0.1); }
  .search-input { padding:8px 14px;background:#f4f5f7;border:1px solid rgba(247,71,53,0.15);border-radius:8px;color:#242b36;font-family:'Prompt',sans-serif;font-size:0.8rem;outline:none;width:200px;max-width:100%; }
  .search-input::placeholder { color:#8a919e; }
  .avatar-sm { width:28px;height:28px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:0.72rem;font-weight:600;flex-shrink:0; }
  .two-col { display:grid;grid-template-columns:1fr 1fr;gap:20px; }
  /* Support Chat */
  .sp-wrap{display:grid;grid-template-columns:280px 1fr;gap:0;height:calc(100vh - 180px);min-height:480px;background:#ffffff;border:1px solid rgba(247,71,53,0.12);border-radius:14px;overflow:hidden;}
  .sp-list{border-right:1px solid rgba(247,71,53,0.1);overflow-y:auto;display:flex;flex-direction:column;}
  .sp-list-head{padding:14px 16px;font-size:0.68rem;letter-spacing:1.5px;text-transform:uppercase;color:#8a919e;border-bottom:1px solid rgba(247,71,53,0.08);flex-shrink:0;}
  .sp-conv,.sp-conv-item{padding:12px 14px;cursor:pointer;border-bottom:1px solid rgba(247,71,53,0.06);transition:background 0.15s;display:flex;align-items:center;gap:10px;}
  .sp-conv:hover,.sp-conv-item:hover{background:rgba(247,71,53,0.04);}
  .sp-conv.active,.sp-conv-item.active{background:rgba(247,71,53,0.08);border-right:2px solid #dc3728;}
  .sp-conv-av{width:36px;height:36px;border-radius:50%;background:linear-gradient(135deg,#1a3a25,#2a5a35);display:flex;align-items:center;justify-content:center;font-size:1rem;font-weight:700;color:#dc3728;flex-shrink:0;}
  .sp-conv-info{flex:1;min-width:0;}
  .sp-conv-name{font-size:0.82rem;font-weight:600;color:#242b36;margin-bottom:3px;display:flex;align-items:center;gap:6px;}
  .sp-conv-badge{background:#ff5555;color:#fff;font-size:0.6rem;padding:1px 5px;border-radius:100px;font-weight:700;}
  .sp-conv-last{font-size:0.72rem;color:#929aa7;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
  .sp-unread-dot{width:8px;height:8px;border-radius:50%;background:#c77b27;flex-shrink:0;}
  .sp-chat{display:flex;flex-direction:column;overflow:hidden;min-height:0;}
  .sp-chat-head{padding:14px 18px;background:#ffffff;border-bottom:1px solid rgba(247,71,53,0.1);flex-shrink:0;}
  .sp-chat-name{font-size:0.9rem;font-weight:700;color:#242b36;}
  .sp-chat-email{font-size:0.72rem;color:#929aa7;}
  .sp-msgs{flex:1;overflow-y:auto;padding:14px 16px;display:flex;flex-direction:column;gap:8px;}
  .sp-msg{max-width:76%;padding:8px 13px;border-radius:12px;font-family:'Prompt',sans-serif;font-size:0.82rem;line-height:1.55;}
  .sp-msg.user{align-self:flex-start;background:#f4f5f7;border:1px solid rgba(247,71,53,0.12);color:#394554;border-bottom-left-radius:4px;}
  .sp-msg.admin{align-self:flex-end;background:rgba(247,71,53,0.12);border:1px solid rgba(247,71,53,0.2);color:#242b36;border-bottom-right-radius:4px;}
  .sp-msg-time{font-size:0.6rem;color:#929aa7;margin-top:3px;display:block;}
  .sp-inputbar{padding:12px 14px;border-top:1px solid rgba(247,71,53,0.1);display:flex;gap:8px;align-items:flex-end;background:#ffffff;flex-shrink:0;}
  .sp-textarea{flex:1;background:rgba(247,71,53,0.04);border:1px solid rgba(247,71,53,0.15);border-radius:10px;padding:9px 12px;color:#242b36;font-family:'Prompt',sans-serif;font-size:0.83rem;resize:none;outline:none;max-height:80px;line-height:1.5;}
  .sp-textarea:focus{border-color:rgba(247,71,53,0.4);}
  .sp-sendbtn{padding:9px 18px;border-radius:10px;border:none;background:#dc3728;color:#f5f6f8;font-family:'Prompt',sans-serif;font-size:0.85rem;font-weight:700;cursor:pointer;flex-shrink:0;transition:background 0.18s;}
  .sp-sendbtn:hover{background:#e63626;}
  .sp-sendbtn:disabled{opacity:0.4;cursor:not-allowed;}
  .sp-empty{flex:1;display:flex;align-items:center;justify-content:center;color:#e2e6ee;font-size:0.85rem;}
  @media(max-width:768px){
    .sp-wrap{grid-template-columns:1fr;height:auto;border-radius:10px;}
    .sp-list{height:auto;max-height:260px;border-right:none;border-bottom:1px solid rgba(247,71,53,0.1);}
    .sp-chat{height:420px;}
    .sp-msgs{padding:10px 12px;}
    .sp-msg{max-width:88%;font-size:0.78rem;}
    .sp-inputbar{padding:8px 10px;}
    .sp-conv-item,.sp-conv{padding:10px 12px;}
    .sp-sendbtn{padding:8px 14px;font-size:0.8rem;}
  }
  @media(max-width:480px){
    .sp-list{max-height:200px;}
    .sp-chat{height:360px;}
    .sp-conv-av{width:30px;height:30px;font-size:0.85rem;}
    .sp-chat-head{padding:10px 12px;}
  }
  /* mobile back btn inside support chat */
  .sp-back-btn{display:none;background:none;border:none;color:#dc3728;font-size:0.8rem;cursor:pointer;padding:4px 8px;font-family:'Prompt',sans-serif;}
  @media(max-width:768px){.sp-back-btn{display:inline-flex;align-items:center;gap:4px;}}
  /* Coupon page */
  .coupon-grid{display:grid;grid-template-columns:380px 1fr;gap:20px;align-items:start;}
  .coupon-form-card{background:#ffffff;border:1px solid rgba(247,71,53,0.12);border-radius:12px;padding:20px;}
  .coupon-form-title{font-size:0.85rem;font-weight:600;margin-bottom:16px;color:#dc3728;}
  .cf-group{margin-bottom:12px;}
  .cf-label{display:block;font-size:0.68rem;letter-spacing:1px;text-transform:uppercase;color:#8a919e;margin-bottom:5px;}
  .cf-input{width:100%;padding:9px 12px;background:#f4f5f7;border:1px solid rgba(247,71,53,0.15);border-radius:8px;color:#242b36;font-family:'Prompt',sans-serif;font-size:0.82rem;outline:none;transition:border-color 0.2s;box-sizing:border-box;}
  .cf-input:focus{border-color:rgba(247,71,53,0.4);}
  .cf-input::placeholder{color:#8a919e;}
  .cf-row{display:grid;grid-template-columns:1fr 1fr;gap:8px;}
  .cf-type-btns{display:flex;gap:6px;}
  .cf-type-btn{flex:1;padding:9px;border-radius:8px;border:1px solid rgba(247,71,53,0.15);background:transparent;color:#8a919e;font-family:'Prompt',sans-serif;font-size:0.78rem;cursor:pointer;transition:all 0.2s;text-align:center;}
  .cf-type-btn.active{background:rgba(247,71,53,0.1);border-color:rgba(247,71,53,0.4);color:#dc3728;font-weight:600;}
  .cf-submit{width:100%;padding:11px;background:#dc3728;border:none;border-radius:8px;color:#f5f6f8;font-family:'Prompt',sans-serif;font-size:0.88rem;font-weight:700;cursor:pointer;margin-top:6px;transition:all 0.2s;}
  .cf-submit:hover{background:#e63626;}
  .cf-submit:disabled{opacity:0.5;cursor:not-allowed;}
  .cf-err{background:rgba(255,85,85,0.1);border:1px solid rgba(255,85,85,0.25);border-radius:8px;padding:8px 12px;color:#ff5555;font-size:0.75rem;margin-bottom:12px;}
  .cf-ok{background:rgba(247,71,53,0.08);border:1px solid rgba(247,71,53,0.2);border-radius:8px;padding:8px 12px;color:#dc3728;font-size:0.75rem;margin-bottom:12px;}
  .coupon-code-badge{font-family:'DM Mono',monospace;background:rgba(247,71,53,0.08);color:#dc3728;padding:3px 10px;border-radius:6px;font-size:0.8rem;letter-spacing:1.5px;}
  .coupon-usage{font-size:0.72rem;color:#8a919e;}
  .coupon-progress{height:4px;background:rgba(255,255,255,0.06);border-radius:2px;margin-top:3px;overflow:hidden;}
  .coupon-progress-bar{height:4px;border-radius:2px;background:#dc3728;transition:width 0.3s;}
  .toggle-btn{padding:5px 12px;border-radius:6px;border:none;font-family:'Prompt',sans-serif;font-size:0.72rem;font-weight:600;cursor:pointer;transition:all 0.2s;}
  .toggle-btn.on{background:rgba(247,71,53,0.1);color:#dc3728;border:1px solid rgba(247,71,53,0.3);}
  .toggle-btn.off{background:rgba(255,85,85,0.1);color:#ff5555;border:1px solid rgba(255,85,85,0.3);}
  @media(max-width:900px){.coupon-grid{grid-template-columns:1fr;}}
  /* Withdrawals */
  .wd-bank{font-size:0.78rem;color:#242b36;font-weight:600;}
  .wd-acc{font-size:0.72rem;color:#8a919e;margin-top:2px;}
  .wd-reject-input{padding:6px 10px;background:#f4f5f7;border:1px solid rgba(255,85,85,0.3);border-radius:6px;color:#242b36;font-family:'Prompt',sans-serif;font-size:0.75rem;outline:none;width:150px;}
  .wd-reject-input::placeholder{color:#8a919e;}
  .wd-ref-input{padding:6px 10px;background:#f4f5f7;border:1px solid rgba(247,71,53,0.2);border-radius:6px;color:#242b36;font-family:'Prompt',sans-serif;font-size:0.75rem;outline:none;width:150px;}
  .wd-ref-input::placeholder{color:#8a919e;}
  .copy-btn{padding:3px 8px;border-radius:5px;border:1px solid rgba(247,71,53,0.2);background:transparent;color:#8a919e;font-size:0.65rem;cursor:pointer;font-family:'Prompt',sans-serif;transition:all 0.15s;white-space:nowrap;}
  .copy-btn:hover{border-color:#dc3728;color:#dc3728;background:rgba(247,71,53,0.06);}
  .copy-btn.copied{border-color:rgba(247,71,53,0.4);color:#dc3728;background:rgba(247,71,53,0.08);}
  .wd-approved-info{font-size:0.72rem;color:#8a919e;line-height:1.6;}
  .wd-approved-info strong{color:#dc3728;}
  /* Province page */
  .prov-cards{display:grid;grid-template-columns:repeat(auto-fill,minmax(160px,1fr));gap:10px;margin-bottom:20px;}
  .prov-card{background:#ffffff;border:1px solid rgba(247,71,53,0.1);border-radius:10px;padding:14px 16px;cursor:pointer;transition:all 0.2s;}
  .prov-card:hover{border-color:rgba(247,71,53,0.35);background:#f4f5f7;}
  .prov-card.selected{border-color:#dc3728;background:rgba(247,71,53,0.07);}
  .prov-card.all-btn{border-style:dashed;}
  .prov-card-name{font-size:0.82rem;font-weight:600;margin-bottom:6px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
  .prov-card-count{font-family:'DM Serif Display',serif;font-size:1.5rem;color:#dc3728;line-height:1;}
  .prov-card-pct{font-size:0.68rem;color:#8a919e;margin-top:3px;}
  .prov-mini-bar{height:3px;background:rgba(255,255,255,0.05);border-radius:2px;margin-top:8px;overflow:hidden;}
  .prov-mini-fill{height:3px;border-radius:2px;background:#dc3728;}
  .prov-user-panel{background:#ffffff;border:1px solid rgba(247,71,53,0.15);border-radius:12px;overflow:hidden;}
  .prov-panel-header{display:flex;align-items:center;justify-content:space-between;padding:14px 20px;border-bottom:1px solid rgba(247,71,53,0.08);}
  .prov-panel-title{font-size:0.92rem;font-weight:600;}
  .prov-panel-sub{font-size:0.72rem;color:#8a919e;margin-top:2px;}
  .prov-user-row{display:flex;align-items:center;gap:12px;padding:12px 20px;border-bottom:1px solid rgba(247,71,53,0.04);}
  .prov-user-row:last-child{border-bottom:none;}
  .prov-user-row:hover{background:rgba(247,71,53,0.02);}
  .prov-avatar{width:34px;height:34px;border-radius:50%;background:linear-gradient(135deg,#1a3a25,#2a5a35);display:flex;align-items:center;justify-content:center;font-size:0.85rem;font-weight:700;color:#dc3728;flex-shrink:0;}
  .prov-user-info{flex:1;min-width:0;}
  .prov-user-name{font-size:0.84rem;font-weight:600;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
  .prov-user-email{font-size:0.72rem;color:#8a919e;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
  .prov-user-meta{display:flex;flex-direction:column;align-items:flex-end;gap:2px;flex-shrink:0;}
  .prov-wallet{font-size:0.78rem;color:#dc3728;font-weight:600;}
  .prov-deals{font-size:0.68rem;color:#8a919e;}
  @media(max-width:768px){.prov-cards{grid-template-columns:repeat(auto-fill,minmax(130px,1fr));}}
  @media(max-width:480px){.prov-cards{grid-template-columns:repeat(3,1fr);gap:7px;}.prov-card{padding:10px 10px;}.prov-card-name{font-size:0.72rem;}.prov-card-count{font-size:1.2rem;}}
  /* Mobile bottom nav */
  .admin-mobile-nav{display:none;position:fixed;bottom:0;left:0;right:0;background:#ffffff;border-top:1px solid rgba(247,71,53,0.12);z-index:100;padding:2px 0 env(safe-area-inset-bottom,6px);}
  .amn-inner{display:grid;grid-template-columns:repeat(5,1fr);gap:0;}
  .amn-row2{display:grid;grid-template-columns:repeat(5,1fr);gap:0;border-top:1px solid rgba(247,71,53,0.07);}
  .amn-btn{display:flex;flex-direction:column;align-items:center;gap:1px;background:none;border:none;color:#8a919e;font-size:0.5rem;cursor:pointer;padding:5px 2px;transition:all 0.2s;font-family:'Prompt',sans-serif;width:100%;letter-spacing:0.2px;}
  .amn-btn .amn-icon{font-size:1.15rem;line-height:1;}
  .amn-btn.active{color:#dc3728;}
  .amn-btn.home-btn{color:#dc3728;font-weight:600;}
  .amn-badge{background:#ff5555;color:#fff;font-size:0.5rem;padding:1px 4px;border-radius:100px;font-weight:700;margin-left:2px;}
  @media(max-width:1024px){.stats-grid{grid-template-columns:repeat(2,1fr)}.two-col{grid-template-columns:1fr}}
  @media(max-width:768px){
    .admin-nav{display:none;}
    .admin-mobile-nav{display:block;}
    .admin-content{padding:16px 14px 130px;}
    .admin-topbar{padding:12px 16px;}
    .stats-grid{grid-template-columns:1fr 1fr;}
    .topbar-actions{gap:6px;}
    .search-input{width:120px;font-size:0.75rem;padding:6px 10px;}
    .tb-btn{padding:6px 10px;font-size:0.72rem;}
    .two-col{grid-template-columns:1fr;}
    .admin-topbar .page-title{font-size:0.95rem;}
    .data-table-wrap{overflow-x:auto;-webkit-overflow-scrolling:touch;border-radius:10px;}
    .data-table{min-width:560px;}
    .data-table th,.data-table td{padding:10px 10px;font-size:0.75rem;}
    .badge{font-size:0.62rem;padding:2px 7px;}
    .stat-card{padding:14px 16px;}
    .stat-num{font-size:1.6rem;}
  }
  @media(max-width:480px){
    .stats-grid{grid-template-columns:1fr;}
    .t-action{font-size:0.68rem;padding:4px 8px;}
    .admin-topbar{flex-direction:column;align-items:flex-start;gap:10px;}
    .topbar-actions{width:100%;}
    .search-input{width:100%;max-width:100%;}
    .coupon-grid{grid-template-columns:1fr;}
    .data-table{min-width:480px;}
    .data-table th,.data-table td{padding:8px 8px;font-size:0.7rem;}
    .action-link{font-size:0.7rem;padding:3px 6px;}
  }
`;

const PAGES = {
  dashboard: { title: "แดชบอร์ด",    sub: "ภาพรวมระบบ Klang" },
  deals:     { title: "จัดการดีล",   sub: "ดีลทั้งหมดในระบบ" },
  disputes:  { title: "ข้อพิพาท",    sub: "เคสที่รอการตรวจสอบ" },
  users:     { title: "ผู้ใช้งาน",   sub: "จัดการบัญชีผู้ใช้" },
  finance:   { title: "การเงิน",      sub: "รายการธุรกรรมทั้งหมด" },
  coupons:   { title: "คูปองส่วนลด", sub: "จัดการรหัสส่วนลดค่าธรรมเนียม" },
  provinces:   { title: "จังหวัดผู้ใช้",   sub: "สถิติผู้ใช้แยกตามจังหวัด" },
  topups:      { title: "เติมเงิน",         sub: "คำขอแจ้งโอนเงินที่รอตรวจสลิป" },
  withdrawals: { title: "ถอนเงิน",         sub: "คำขอถอนเงินที่รอการอนุมัติ" },
  reviews:     { title: "รีวิว",            sub: "คะแนนรีวิวจากผู้ใช้งาน" },
  support:     { title: "Support Chat",    sub: "แชทตอบคำถามลูกค้าโดยตรง" },
};

// ── Export CSV helper ─────────────────────────────────────────────────────
function exportCSV(filename, headers, rows) {
  const BOM = "﻿"; // UTF-8 BOM สำหรับ Excel
  const esc = (v) => `"${String(v ?? "").replace(/"/g, '""')}"`;
  const csv = [headers.map(esc).join(","), ...rows.map((r) => r.map(esc).join(","))].join("\n");
  const blob = new Blob([BOM + csv], { type: "text/csv;charset=utf-8;" });
  const url  = URL.createObjectURL(blob);
  const a    = document.createElement("a");
  a.href = url; a.download = filename; document.body.appendChild(a); a.click();
  document.body.removeChild(a); URL.revokeObjectURL(url);
}

export default function AdminPage() {
  const navigate = useNavigate();
  const [page, setPage] = useState("dashboard");
  const [search, setSearch] = useState("");
  const [deals, setDeals] = useState([]);
  const [disputes, setDisputes] = useState([]);
  const [users, setUsers] = useState([]);
  const [transactions, setTransactions] = useState([]);
  const [coupons, setCoupons] = useState([]);
  const [withdrawals, setWithdrawals] = useState([]);
  const [topupRequests, setTopupRequests] = useState([]);
  const [topupRejectNotes, setTopupRejectNotes] = useState({});
  const [slipModal, setSlipModal] = useState(null); // base64 string ของสลิปที่กำลังดู
  const [rejectNotes,  setRejectNotes]  = useState({}); // withdrawId → note text
  const [approveRefs,  setApproveRefs]  = useState({}); // withdrawId → transfer ref
  const [copiedId,     setCopiedId]     = useState(null); // id ที่เพิ่ง copy
  const [reviews, setReviews]         = useState([]);
  const [supportChats, setSupportChats] = useState([]);
  const [activeChatUid, setActiveChatUid] = useState(null);
  // จำนวนข้อความจากลูกค้าที่ยังไม่ได้อ่าน แยกตามห้อง (chatId → count) — อิงจาก flag
  // ระดับ "ข้อความ" (readByAdmin) แทนตัวนับกลางตัวเดียวที่แก้ไขแข่งกันได้ (race) ระหว่าง
  // การ increment ฝั่งลูกค้ากับการรีเซ็ตฝั่งแอดมิน
  const [unreadByChat, setUnreadByChat] = useState({});
  // นับห้องที่ยังไม่อ่าน โดยไม่รวมห้องที่เปิดดูอยู่ตอนนี้ (แอดมินเห็นข้อความอยู่แล้วแบบ real-time
  // จึงไม่ควรขึ้น badge ให้ห้องนั้น)
  const supportUnread = useMemo(
    () => Object.entries(unreadByChat).filter(([id, n]) => n > 0 && id !== activeChatUid).length,
    [unreadByChat, activeChatUid]
  );
  const [chatMsgs, setChatMsgs]       = useState([]);
  const [replyInput, setReplyInput]   = useState("");
  const [replySending, setReplySending] = useState(false);
  const supportMsgsRef = useRef(null);
  const [filterStatus, setFilterStatus] = useState("ทั้งหมด");
  const [selectedProvince, setSelectedProvince] = useState("__all__"); // "__all__" = ทั้งหมด
  const [confirmModal, setConfirmModal] = useState(null); // { message, onConfirm }
  const [feePeriod, setFeePeriod]       = useState("month"); // today|week|month|last_month|all

  // ── coupon form state ──────────────────────────────────────────────────────
  const [cfCode,       setCfCode]       = useState("");
  const [cfType,       setCfType]       = useState("percent"); // "percent" | "flat"
  const [cfValue,      setCfValue]      = useState("");
  const [cfMaxUses,    setCfMaxUses]    = useState("");
  const [cfMinPrice,   setCfMinPrice]   = useState("");
  const [cfMaxDiscount,setCfMaxDiscount]= useState("");
  const [cfExpires,    setCfExpires]    = useState("");
  const [cfAudience,   setCfAudience]   = useState("all"); // "all" = ทุกคน | "members" = สมาชิกเฉพาะราย
  const [cfOwnerEmail, setCfOwnerEmail] = useState("");
  const [cfSharePct,   setCfSharePct]   = useState("");
  const [cfLoading,    setCfLoading]    = useState(false);
  const [cfErr,        setCfErr]        = useState("");
  const [cfOk,         setCfOk]         = useState("");
  const info = PAGES[page] || PAGES.dashboard;

  // ── โหลดดีลทั้งหมดจาก Firestore ──────────────────────────────────────────
  useEffect(() => {
    const q = query(collection(db, "rooms"), orderBy("createdAt", "desc"));
    const unsub = onSnapshot(q, (snap) => {
      setDeals(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
    });
    return () => unsub();
  }, []);

  // ── โหลดห้องที่มีสถานะ disputed จาก Firestore ──────────────────────────
  useEffect(() => {
    const q = query(
      collection(db, "rooms"),
      where("status", "==", "disputed")
    );
    const unsub = onSnapshot(q, (snap) => {
      setDisputes(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
    });
    return () => unsub();
  }, []);

  // ── โหลด users ทั้งหมด ───────────────────────────────────────────────────
  useEffect(() => {
    const unsub = onSnapshot(collection(db, "users"), (snap) => {
      setUsers(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
    });
    return () => unsub();
  }, []);

  // ── โหลด transactions ทั้งหมด ────────────────────────────────────────────
  useEffect(() => {
    const q = query(collection(db, "transactions"), orderBy("createdAt", "desc"));
    const unsub = onSnapshot(q, (snap) => {
      setTransactions(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
    });
    return () => unsub();
  }, []);

  // ── โหลด coupons ─────────────────────────────────────────────────────────
  useEffect(() => {
    const q = query(collection(db, "coupons"), orderBy("createdAt", "desc"));
    const unsub = onSnapshot(q, (snap) => {
      setCoupons(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
    });
    return () => unsub();
  }, []);

  // ── โหลด withdrawals ──────────────────────────────────────────────────────
  useEffect(() => {
    const q = query(collection(db, "withdrawals"), orderBy("createdAt", "desc"));
    const unsub = onSnapshot(q, (snap) => {
      setWithdrawals(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
    });
    return () => unsub();
  }, []);

  // ── โหลด topup_requests ───────────────────────────────────────────────────
  useEffect(() => {
    const q = query(collection(db, "topup_requests"), orderBy("createdAt", "desc"));
    const unsub = onSnapshot(q, (snap) => {
      setTopupRequests(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
    });
    return () => unsub();
  }, []);

  // ── โหลด reviews ─────────────────────────────────────────────────────────
  useEffect(() => {
    const unsub = onSnapshot(collection(db, "reviews"), (snap) => {
      setReviews(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
    });
    return () => unsub();
  }, []);

  // ── โหลด support chats ────────────────────────────────────────────────────
  const supportFirstLoad = useRef(true);   // ข้ามเสียงตอนโหลดหน้าครั้งแรก เล่นเฉพาะข้อความใหม่จริง ๆ
  const supportLastAtRef = useRef({});     // chatId → เวลาข้อความล่าสุดที่เคยเห็น (กันเสียงซ้ำตอน field อื่นเปลี่ยนโดยไม่มีข้อความใหม่)
  useEffect(() => {
    const unsub = onSnapshot(
      query(collection(db, "supportChats"), orderBy("lastAt", "desc")),
      (snap) => {
        const list = snap.docs.map(d => ({ id: d.id, ...d.data() }));
        setSupportChats(list);

        // มีลูกค้าส่งข้อความใหม่เข้ามาจริง ๆ (เทียบเวลาข้อความล่าสุด ไม่ใช่แค่ field อื่นเปลี่ยน)
        // → เล่นเสียงแจ้งเตือน ไม่ว่าจะเป็นห้องไหนในรายการ
        if (!supportFirstLoad.current) {
          let shouldDing = false;
          snap.docChanges().forEach((c) => {
            if (c.type !== "added" && c.type !== "modified") return;
            const data = c.doc.data();
            const ms = data.lastAt?.toMillis ? data.lastAt.toMillis() : null;
            if (data.lastSender === "user" && ms !== null && ms !== supportLastAtRef.current[c.doc.id]) {
              shouldDing = true;
            }
          });
          if (shouldDing) playNotifSound();
        }
        list.forEach((c) => {
          const ms = c.lastAt?.toMillis ? c.lastAt.toMillis() : null;
          if (ms !== null) supportLastAtRef.current[c.id] = ms;
        });
        supportFirstLoad.current = false;
      },
      () => {}
    );
    return () => unsub();
  }, []);

  // ── โหลด messages ของ chat ที่เลือก + มาร์คว่าอ่านแล้วทันทีที่เห็น ───────────
  // มาร์คทีละข้อความ (ไม่ใช่ตัวนับกลาง) เพื่อไม่ให้เกิดปัญหาจังหวะ (race) เวลาข้อความใหม่
  // จากลูกค้ามาถึงตอนที่ Admin เปิดห้องนี้ดูอยู่พอดี — เช็คใหม่ทุกครั้งที่ snapshot อัปเดต
  // จึงครอบคลุมทั้งตอนเพิ่งเปิดห้อง และตอนมีข้อความใหม่เข้ามาขณะเปิดค้างไว้
  useEffect(() => {
    if (!activeChatUid) return;
    const q = query(collection(db, "supportChats", activeChatUid, "messages"), orderBy("createdAt", "asc"));
    const unsub = onSnapshot(q, (snap) => {
      setChatMsgs(snap.docs.map(d => ({ id: d.id, ...d.data() })));
      setTimeout(() => { if (supportMsgsRef.current) supportMsgsRef.current.scrollTop = supportMsgsRef.current.scrollHeight; }, 50);

      const unread = snap.docs.filter(d => d.data().isAdmin === false && d.data().readByAdmin !== true);
      if (unread.length) {
        const batch = writeBatch(db);
        unread.forEach(d => batch.update(d.ref, { readByAdmin: true }));
        batch.commit().catch(() => {});
      }
    });
    return () => unsub();
  }, [activeChatUid]);

  // ── นับข้อความที่ยังไม่ได้อ่านแยกตามห้อง (subscribe 1 อันต่อห้อง) ──────────
  // resubscribe เฉพาะตอนรายชื่อห้อง (id) เปลี่ยน ไม่ใช่ทุกครั้งที่มีข้อความใหม่
  const chatIdsKey = supportChats.map((c) => c.id).join(",");
  useEffect(() => {
    const ids = chatIdsKey ? chatIdsKey.split(",") : [];
    const unsubs = ids.map((id) =>
      onSnapshot(
        query(
          collection(db, "supportChats", id, "messages"),
          where("isAdmin", "==", false),
          where("readByAdmin", "==", false)
        ),
        (snap) => setUnreadByChat((prev) => ({ ...prev, [id]: snap.size })),
        () => {}
      )
    );
    return () => unsubs.forEach((u) => u());
  }, [chatIdsKey]);

  // ── ส่งข้อความ Admin reply ────────────────────────────────────────────────
  const sendAdminReply = async () => {
    const text = replyInput.trim();
    if (!text || replySending || !activeChatUid) return;
    setReplyInput(""); setReplySending(true);
    try {
      await addDoc(collection(db, "supportChats", activeChatUid, "messages"), {
        text, isAdmin: true, senderName: "Admin",
        readByUser: false, readByAdmin: true,
        createdAt: serverTimestamp(),
      });
      await setDoc(doc(db, "supportChats", activeChatUid), { lastMsg: text, lastAt: serverTimestamp(), lastSender: "admin" }, { merge: true });
    } catch {}
    setReplySending(false);
  };

  const pendingTopupCount     = topupRequests.filter(t => t.status === "pending").length;
  const pendingWithdrawCount  = withdrawals.filter(w => w.status === "pending").length;
  // แดชบอร์ด = ผลรวมของทุกรายการที่ "รอดำเนินการ" อยู่จริงในระบบ ณ ตอนนี้
  const dashboardBadge = disputes.length + pendingTopupCount + pendingWithdrawCount + supportUnread;

  // ── จำ "เวลาที่แอดมินเปิดดูเมนูนี้ล่าสุด" ไว้ในเครื่อง เพื่อให้ badge ของเมนูที่เป็น
  // รายการเหตุการณ์ (ดีล/ผู้ใช้/ธุรกรรม/คูปอง/รีวิว) นับเฉพาะ "รายการใหม่หลังจากนั้น"
  // แล้วหายไปทันทีที่กดเข้าไปดู — เหมือนพฤติกรรมที่ Support Chat ทำได้แล้ว
  const [lastSeenMenus, setLastSeenMenus] = useState(() => {
    try { return JSON.parse(localStorage.getItem("klang-admin-lastseen") || "{}"); }
    catch { return {}; }
  });
  const markMenuSeen = (key) => {
    setLastSeenMenus((prev) => {
      const next = { ...prev, [key]: Date.now() };
      try { localStorage.setItem("klang-admin-lastseen", JSON.stringify(next)); } catch {}
      return next;
    });
  };
  const countNewSince = (list, key) => {
    const since = lastSeenMenus[key] || 0;
    return list.filter((item) => {
      const t = item.createdAt?.toMillis ? item.createdAt.toMillis()
        : item.createdAt ? new Date(item.createdAt).getTime() : 0;
      return t > since;
    }).length;
  };

  const NAV_ITEMS = [
    { key: "dashboard", icon: "chart", label: "แดชบอร์ด", badge: dashboardBadge || null, badgeCls: "danger" },
    { key: "deals",     icon: "briefcase", label: "ดีลทั้งหมด", badge: countNewSince(deals, "deals") || null, badgeCls: "" },
    { key: "disputes",  icon: "alert", label: "ข้อพิพาท", badge: disputes.length || null, badgeCls: "danger" },
    { key: "users",     icon: "users", label: "ผู้ใช้งาน", badge: countNewSince(users, "users") || null, badgeCls: "" },
    { key: "finance",   icon: "wallet", label: "การเงิน", badge: countNewSince(transactions, "finance") || null, badgeCls: "" },
    { key: "coupons",   icon: "ticket", label: "คูปอง", badge: countNewSince(coupons, "coupons") || null, badgeCls: "" },
    { key: "provinces",   icon: "pin", label: "จังหวัด", badge: countNewSince(users, "provinces") || null, badgeCls: "" },
    { key: "topups",      icon: "coin", label: "เติมเงิน", badge: pendingTopupCount || null, badgeCls: "warning" },
    { key: "withdrawals", icon: "bank", label: "ถอนเงิน", badge: pendingWithdrawCount || null, badgeCls: "warning" },
    { key: "reviews",     icon: "star", label: "รีวิว", badge: countNewSince(reviews, "reviews") || null, badgeCls: "" },
    { key: "support",     icon: "message", label: "Support Chat", badge: supportUnread || null, badgeCls: "warning" },
  ];

  // หาผู้ใช้จากอีเมล (ไม่สนตัวพิมพ์เล็ก/ใหญ่)
  const findUserByEmail = (email) => {
    const em = (email || "").trim().toLowerCase();
    return em ? users.find((x) => (x.email || "").toLowerCase() === em) : null;
  };

  // แจ้งเตือนเจ้าของคูปอง (best-effort — ไม่ทำให้การบันทึกล้มถ้าแจ้งไม่สำเร็จ)
  const notifyCouponOwner = (uid, code, pct) => {
    addDoc(collection(db, "users", uid, "notifications"), {
      type: "coupon", title: "คุณเป็นเจ้าของคูปอง",
      message: `คูปอง ${code} — เมื่อมีคนใช้และดีลสำเร็จ คุณได้ส่วนแบ่ง ${pct}% ของค่าธรรมเนียม`,
      roomId: null, read: false, createdAt: serverTimestamp(),
    }).catch(() => {});
  };

  // ── สร้างคูปองใหม่ ────────────────────────────────────────────────────────
  const handleCreateCoupon = async (e) => {
    e.preventDefault();
    setCfErr(""); setCfOk("");
    if (!cfCode.trim())   { setCfErr("กรุณากรอกรหัสคูปอง"); return; }
    if (!cfValue)         { setCfErr("กรุณากรอกค่าส่วนลด"); return; }
    if (Number(cfValue) <= 0) { setCfErr("ค่าส่วนลดต้องมากกว่า 0"); return; }
    if (cfType === "percent" && Number(cfValue) > 100) { setCfErr("ส่วนลด % ต้องไม่เกิน 100"); return; }
    // ตรวจ code ซ้ำ
    if (coupons.some((c) => c.code === cfCode.trim().toUpperCase())) {
      setCfErr("รหัสคูปองนี้มีอยู่แล้ว"); return;
    }
    let owner = null;
    let sharePct = 0;
    if (cfAudience === "members") {
      owner = findUserByEmail(cfOwnerEmail);
      if (!owner) { setCfErr("ไม่พบสมาชิกอีเมลนี้ในระบบ"); return; }
      sharePct = Number(cfSharePct);
      if (!Number.isFinite(sharePct) || sharePct < 0 || sharePct > 100) { setCfErr("ส่วนแบ่งต้องเป็นตัวเลข 0-100"); return; }
    }
    setCfLoading(true);
    try {
      const data = {
        code:      cfCode.trim().toUpperCase(),
        type:      cfType,
        value:     Number(cfValue),
        maxUses:   cfMaxUses    ? Number(cfMaxUses)    : null,
        minPrice:  cfMinPrice   ? Number(cfMinPrice)   : null,
        maxDiscount: cfType === "percent" && cfMaxDiscount ? Number(cfMaxDiscount) : null,
        expiresAt: cfExpires    ? Timestamp.fromDate(new Date(cfExpires)) : null,
        usedCount: 0,
        usedBy:    [],
        isActive:  true,
        ...(owner ? { ownerId: owner.id, ownerSharePercent: sharePct } : {}),
        createdAt: serverTimestamp(),
      };
      await addDoc(collection(db, "coupons"), data);
      if (owner) notifyCouponOwner(owner.id, data.code, sharePct);
      setCfOk(`สร้างคูปอง "${data.code}"${owner ? ` ของ ${owner.name || owner.email} (ส่วนแบ่ง ${sharePct}%)` : ""} สำเร็จ!`);
      setCfCode(""); setCfValue(""); setCfMaxUses(""); setCfMinPrice("");
      setCfMaxDiscount(""); setCfExpires(""); setCfOwnerEmail(""); setCfSharePct("");
    } catch (err) {
      setCfErr("สร้างคูปองไม่สำเร็จ: " + err.message);
    }
    setCfLoading(false);
  };

  // ── Dashboard stats (computed from real Firestore data) ─────────────────
  const todayStart = new Date(); todayStart.setHours(0,0,0,0);
  const _toDate = (ts) => ts?.toDate ? ts.toDate() : (ts ? new Date(ts) : null);
  const dealsToday   = deals.filter(d => { const t = _toDate(d.createdAt); return t && t >= todayStart; }).length;
  const waitingDeals = deals.filter(d => d.status === "deposited" || d.status === "shipped").length;
  const disputeCount = disputes.length;
  const disputeToday = disputes.filter(d => { const t = _toDate(d.createdAt); return t && t >= todayStart; }).length;
  const escrowTotal  = deals.filter(d => d.status === "deposited" || d.status === "shipped").reduce((s, d) => s + (d.lockedAmount || d.price || 0), 0);
  const escrowToday  = deals.filter(d => (d.status === "deposited" || d.status === "shipped") && (() => { const t = _toDate(d.createdAt); return t && t >= todayStart; })()).reduce((s, d) => s + (d.lockedAmount || d.price || 0), 0);
  const fmtMoney = (n) => n >= 1000000 ? `฿${(n/1000000).toFixed(1)}M` : n >= 1000 ? `฿${(n/1000).toFixed(0)}K` : `฿${n.toLocaleString()}`;

  // ── รายได้ค่าธรรมเนียม (จาก transactions type=release, ฟิลด์ fee) ─────────
  const monthStart = new Date(); monthStart.setDate(1); monthStart.setHours(0,0,0,0);
  const feeTxs      = transactions.filter(t => t.type === "release" && (t.fee || 0) > 0);
  const feeTotal    = feeTxs.reduce((s, t) => s + (t.fee || 0), 0);
  const feeToday    = feeTxs.filter(t => { const d = _toDate(t.createdAt); return d && d >= todayStart; }).reduce((s, t) => s + (t.fee || 0), 0);
  // const feeMonth = feeTxs.filter(t => { const d = _toDate(t.createdAt); return d && d >= monthStart; }).reduce((s, t) => s + (t.fee || 0), 0);
  const feeCount    = feeTxs.length;

  return (
    <div className="admin-page kl-admin">
      <style>{css}</style>

      {/* Sidebar */}
      <nav className="admin-nav">
        <div className="nav-logo">
          <div className="logo">
            <span className="kl-wordmark">klang.</span>
          </div>
          <div className="admin-badge">Admin Panel</div>
        </div>
        <div className="nav-section">
          <div className="nav-section-label">เมนูหลัก</div>
          {NAV_ITEMS.map((item) => (
            <button
              key={item.key}
              className={`nav-item${page === item.key ? " active" : ""}`}
              onClick={() => { setPage(item.key); markMenuSeen(item.key); }}
            >
              <span className="icon"><Icon name={item.icon} size={18} /></span>
              {item.label}
              {item.badge && (
                <span
                  className={`nav-badge${item.badgeCls ? " " + item.badgeCls : ""}`}
                >
                  {item.badge}
                </span>
              )}
            </button>
          ))}
        </div>
        <div className="nav-section" style={{ marginTop: "auto" }}>
          <button className="nav-item" onClick={() => navigate("/home")}>
            <span className="icon"><Icon name="home" size={18} /></span> หน้าหลัก
          </button>
          <button
            className="nav-item"
            style={{ color: "#ff5555" }}
            onClick={async () => {
              await signOut(auth);
              localStorage.removeItem("klang-user");
              navigate("/");
            }}
          >
            <span className="icon"><Icon name="logout" size={18} /></span> ออกจากระบบ
          </button>
        </div>
      </nav>

      {/* Mobile Bottom Nav — 2 rows of 5 */}
      <nav className="admin-mobile-nav">
        <div className="amn-inner">
          {NAV_ITEMS.slice(0, 4).map((item) => (
            <button key={item.key} className={`amn-btn${page === item.key ? " active" : ""}`} onClick={() => setPage(item.key)}>
              <span className="amn-icon"><Icon name={item.icon} size={20} /></span>
              {item.label}
              {item.badge ? <span className="amn-badge">{item.badge}</span> : null}
            </button>
          ))}
          <button className="amn-btn home-btn" onClick={() => navigate("/home")}>
            <span className="amn-icon"><Icon name="home" size={20} /></span>
            หน้าหลัก
          </button>
        </div>
        <div className="amn-row2">
          {NAV_ITEMS.slice(4).map((item) => (
            <button key={item.key} className={`amn-btn${page === item.key ? " active" : ""}`} onClick={() => setPage(item.key)}>
              <span className="amn-icon"><Icon name={item.icon} size={20} /></span>
              {item.label}
              {item.badge ? <span className="amn-badge">{item.badge}</span> : null}
            </button>
          ))}
        </div>
      </nav>

      {/* Main */}
      <div className="admin-main">
        <div className="admin-topbar">
          <BackButton fallback="/home" />
          <div>
            <div className="page-title">{info.title}</div>
            <div className="page-subtitle">{info.sub}</div>
          </div>
          <div className="topbar-actions">
            <input
              className="search-input"
              placeholder="ค้นหา..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <button className="tb-btn primary" onClick={() => navigate("/home?create=physical")}>+ สร้างดีล</button>
          </div>
        </div>

        <div className="admin-content">
          {/* ── Dashboard ── */}
          {page === "dashboard" && (
            <>
              <div className="stats-grid">
                {[
                  {
                    label: "ดีลทั้งหมด",
                    num: deals.length.toLocaleString(),
                    change: dealsToday > 0 ? `↑ +${dealsToday} วันนี้` : "ยังไม่มีดีลใหม่วันนี้",
                    cls: dealsToday > 0 ? "up" : "",
                  },
                  {
                    label: "รอยืนยัน",
                    num: waitingDeals.toLocaleString(),
                    change: "ดีลที่รอจัดส่ง/รอรับของ",
                    cls: waitingDeals > 0 ? "up" : "",
                    cardCls: waitingDeals > 0 ? "warning" : "",
                  },
                  {
                    label: "ข้อพิพาทที่เปิด",
                    num: disputeCount.toLocaleString(),
                    change: disputeToday > 0 ? `↑ +${disputeToday} วันนี้` : "ไม่มีข้อพิพาทใหม่",
                    cls: disputeToday > 0 ? "down" : "",
                    cardCls: disputeCount > 0 ? "danger" : "",
                  },
                  {
                    label: "มูลค่าที่คุ้มครอง",
                    num: fmtMoney(escrowTotal),
                    change: escrowToday > 0 ? `↑ +${fmtMoney(escrowToday)} วันนี้` : "ไม่มียอดใหม่วันนี้",
                    cls: escrowToday > 0 ? "up" : "",
                  },
                  {
                    label: "รายได้ค่าธรรมเนียมรวม",
                    num: fmtMoney(feeTotal),
                    change: feeToday > 0 ? `↑ +฿${feeToday.toLocaleString()} วันนี้` : `${feeCount} ดีลที่เสร็จสิ้น`,
                    cls: feeToday > 0 ? "up" : "",
                    cardCls: "info",
                  },
                ].map((s) => (
                  <div
                    key={s.label}
                    className={`stat-card${s.cardCls ? " " + s.cardCls : ""}`}
                  >
                    <div className="stat-label">{s.label}</div>
                    <div className="stat-num">{s.num}</div>
                    <div className={`stat-change ${s.cls}`}>{s.change}</div>
                  </div>
                ))}
              </div>

              {/* ── Fee Revenue Banner ── */}
              {(() => {
                const now = new Date();
                const periodStart = {
                  today:      new Date(now.getFullYear(), now.getMonth(), now.getDate()),
                  week:       new Date(now.getFullYear(), now.getMonth(), now.getDate() - now.getDay()),
                  month:      new Date(now.getFullYear(), now.getMonth(), 1),
                  last_month: new Date(now.getFullYear(), now.getMonth() - 1, 1),
                  all:        new Date(0),
                }[feePeriod];
                const periodEnd = feePeriod === "last_month"
                  ? new Date(now.getFullYear(), now.getMonth(), 1)
                  : new Date(9999, 0);
                const periodTxs = feeTxs.filter(t => {
                  const d = _toDate(t.createdAt);
                  return d && d >= periodStart && d < periodEnd;
                });
                const periodFee   = periodTxs.reduce((s,t) => s + (t.fee||0), 0);
                const periodCount = periodTxs.length;

                // breakdown รายเดือน (ย้อนหลัง 6 เดือน)
                const monthlyMap = {};
                feeTxs.forEach(t => {
                  const d = _toDate(t.createdAt);
                  if (!d) return;
                  const key = `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}`;
                  monthlyMap[key] = (monthlyMap[key] || 0) + (t.fee || 0);
                });
                const monthlyRows = Object.entries(monthlyMap)
                  .sort((a,b) => b[0].localeCompare(a[0]))
                  .slice(0, 6);

                const PERIOD_LABELS = { today:"วันนี้", week:"สัปดาห์นี้", month:"เดือนนี้", last_month:"เดือนที่แล้ว", all:"ทั้งหมด" };

                return (
                  <div style={{background:"linear-gradient(135deg,rgba(85,153,255,0.08),rgba(247,71,53,0.06))",border:"1px solid rgba(85,153,255,0.2)",borderRadius:14,padding:"20px 24px",marginBottom:24}}>
                    {/* Header row */}
                    <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",flexWrap:"wrap",gap:12,marginBottom:20}}>
                      <div style={{fontSize:"0.65rem",letterSpacing:"2px",textTransform:"uppercase",color:"#5599ff"}}>รายได้ค่าธรรมเนียมแพลตฟอร์ม</div>
                      <div style={{display:"flex",gap:8,flexWrap:"wrap",alignItems:"center"}}>
                        {["today","week","month","last_month","all"].map(p => (
                          <button key={p} onClick={() => setFeePeriod(p)}
                            style={{padding:"4px 12px",borderRadius:100,border:"1px solid",fontFamily:"'Prompt',sans-serif",fontSize:"0.72rem",cursor:"pointer",transition:"all 0.2s",
                              background: feePeriod===p ? "rgba(85,153,255,0.2)" : "transparent",
                              borderColor: feePeriod===p ? "#5599ff" : "rgba(85,153,255,0.2)",
                              color: feePeriod===p ? "#5599ff" : "#8a919e",
                              fontWeight: feePeriod===p ? 600 : 400,
                            }}>
                            {PERIOD_LABELS[p]}
                          </button>
                        ))}
                        <button onClick={() => {
                          exportCSV(
                            `klang-fee-${feePeriod}-${new Date().toISOString().slice(0,10)}.csv`,
                            ["วันที่","รหัสห้อง","ค่าธรรมเนียม (฿)"],
                            periodTxs.map(t => [
                              _toDate(t.createdAt)?.toLocaleDateString("th-TH") || "-",
                              t.roomCode || t.roomId?.slice(0,8) || "-",
                              t.fee || 0,
                            ])
                          );
                        }} style={{padding:"4px 14px",borderRadius:100,border:"1px solid rgba(247,71,53,0.3)",background:"rgba(247,71,53,0.08)",color:"#dc3728",fontFamily:"'Prompt',sans-serif",fontSize:"0.72rem",cursor:"pointer",fontWeight:600}}>
                          Export CSV
                        </button>
                      </div>
                    </div>

                    {/* Stats row */}
                    <div style={{display:"flex",alignItems:"center",gap:32,flexWrap:"wrap",marginBottom:20}}>
                      <div>
                        <div style={{fontFamily:"'DM Serif Display',serif",fontSize:"2.4rem",color:"#fff",lineHeight:1}}>
                          ฿{periodFee.toLocaleString()}
                        </div>
                        <div style={{fontSize:"0.75rem",color:"#8a919e",marginTop:4}}>{periodCount} ดีล · {PERIOD_LABELS[feePeriod]}</div>
                      </div>
                      <div style={{width:"1px",height:52,background:"rgba(85,153,255,0.2)",flexShrink:0}} />
                      <div>
                        <div style={{fontSize:"0.62rem",color:"#8a919e",marginBottom:4,letterSpacing:"1px",textTransform:"uppercase"}}>รวมตลอดเวลา</div>
                        <div style={{fontSize:"1.3rem",fontWeight:700,color:"#5599ff"}}>฿{feeTotal.toLocaleString()}</div>
                        <div style={{fontSize:"0.7rem",color:"#8a919e"}}>{feeCount} ดีล</div>
                      </div>
                      <div style={{width:"1px",height:52,background:"rgba(85,153,255,0.2)",flexShrink:0}} />
                      <div>
                        <div style={{fontSize:"0.62rem",color:"#8a919e",marginBottom:4,letterSpacing:"1px",textTransform:"uppercase"}}>เฉลี่ย/ดีล</div>
                        <div style={{fontSize:"1.3rem",fontWeight:700,color:"#dc3728"}}>
                          ฿{feeCount > 0 ? Math.round(feeTotal/feeCount).toLocaleString() : 0}
                        </div>
                      </div>
                    </div>

                    {/* Monthly breakdown */}
                    <div>
                      <div style={{fontSize:"0.65rem",color:"#8a919e",letterSpacing:"1.5px",textTransform:"uppercase",marginBottom:10}}>ย้อนหลังรายเดือน</div>
                      {monthlyRows.length === 0
                        ? <div style={{fontSize:"0.78rem",color:"#e2e6ee"}}>ยังไม่มีข้อมูล</div>
                        : <div style={{display:"flex",flexDirection:"column",gap:6}}>
                          {monthlyRows.map(([key, val]) => {
                            const maxVal = Math.max(...monthlyRows.map(r => r[1]), 1);
                            const pct    = Math.round((val / maxVal) * 100);
                            const [yr, mo] = key.split("-");
                            const label = new Date(Number(yr), Number(mo)-1, 1)
                              .toLocaleDateString("th-TH", { month:"long", year:"numeric" });
                            return (
                              <div key={key} style={{display:"flex",alignItems:"center",gap:10}}>
                                <div style={{fontSize:"0.72rem",color:"#8a919e",width:110,flexShrink:0}}>{label}</div>
                                <div style={{flex:1,height:6,background:"rgba(255,255,255,0.05)",borderRadius:3,overflow:"hidden"}}>
                                  <div style={{width:`${pct}%`,height:"100%",background:"linear-gradient(90deg,#5599ff,#dc3728)",borderRadius:3,transition:"width 0.4s"}} />
                                </div>
                                <div style={{fontSize:"0.75rem",color:"#dc3728",fontWeight:600,width:80,textAlign:"right",flexShrink:0}}>
                                  ฿{val.toLocaleString()}
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      }
                    </div>
                  </div>
                );
              })()}

              <div className="two-col">
                <div className="table-card">
                  <div className="table-header">
                    <div className="table-title">ดีลล่าสุด</div>
                    <div className="table-actions">
                      <button
                        className="t-action"
                        onClick={() => setPage("deals")}
                      >
                        ดูทั้งหมด →
                      </button>
                    </div>
                  </div>
                  <table className="data-table">
                    <thead>
                      <tr>
                        <th>Deal ID</th>
                        <th>สินค้า</th>
                        <th>มูลค่า</th>
                        <th>สถานะ</th>
                      </tr>
                    </thead>
                    <tbody>
                      {deals.slice(0, 4).map((d) => {
                        const STATUS_TH = { created:"รอชำระ", deposited:"รอจัดส่ง", shipped:"กำลังส่ง", completed:"เสร็จสิ้น", released:"เสร็จสิ้น", refunded:"คืนเงินแล้ว", disputed:"ข้อพิพาท" };
                        const STATUS_CLS = { created:"pending", deposited:"pending", shipped:"shipped", completed:"success", released:"success", refunded:"pending", disputed:"dispute" };
                        return (
                          <tr key={d.id}>
                            <td><span className="deal-id">{d.roomCode || d.id.slice(0,6).toUpperCase()}</span></td>
                            <td style={{maxWidth:140,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>
                              {d.itemName || "-"}
                            </td>
                            <td style={{ color: "#dc3728", fontWeight: 600 }}>
                              ฿{(d.price||0).toLocaleString()}
                            </td>
                            <td>
                              <span className={`badge ${STATUS_CLS[d.status]||""}`}>
                                <span className="badge-dot-sm" />
                                {STATUS_TH[d.status] || d.status}
                              </span>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>

                <div className="table-card">
                  <div className="table-header">
                    <div className="table-title">ข้อพิพาทที่รอ</div>
                    <div className="table-actions">
                      <button
                        className="t-action"
                        onClick={() => setPage("disputes")}
                      >
                        ดูทั้งหมด →
                      </button>
                    </div>
                  </div>
                  <table className="data-table">
                    <thead>
                      <tr>
                        <th>เคส</th>
                        <th>สินค้า</th>
                        <th>มูลค่า</th>
                        <th>อายุ</th>
                      </tr>
                    </thead>
                    <tbody>
                      {disputes.slice(0,3).map((d) => (
                        <tr key={d.id} style={{cursor:'pointer'}} onClick={() => navigate(`/chat/${d.id}?admin=true`)}>
                          <td><span className="deal-id">{d.roomCode || d.id.slice(0,6).toUpperCase()}</span></td>
                          <td>{d.itemName || "-"}</td>
                          <td style={{ color: "#ff5555" }}>฿{(d.price||0).toLocaleString()}</td>
                          <td><span className="badge dispute">ข้อพิพาท</span></td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </>
          )}

          {/* ── Deals ── */}
          {page === "deals" && (
            <div className="table-card">
              <div className="table-header">
                <div className="table-title">ดีลทั้งหมด ({deals.length})</div>
                <div className="table-actions">
                  {["ทั้งหมด","created","deposited","shipped","released","disputed"].map((f) => (
                    <button key={f} className={`t-action${filterStatus===f?' active':''}`}
                      onClick={() => setFilterStatus(f)}
                      style={filterStatus===f?{background:'rgba(247,71,53,0.15)',color:'#dc3728',border:'1px solid rgba(247,71,53,0.3)'}:{}}>
                      {f === "ทั้งหมด" ? "ทั้งหมด" : f === "created" ? "รอชำระ" : f === "deposited" ? "รอจัดส่ง" : f === "shipped" ? "กำลังส่ง" : f === "released" ? "เสร็จสิ้น" : "ข้อพิพาท"}
                    </button>
                  ))}
                  <button className="t-action" style={{color:'#dc3728',borderColor:'rgba(247,71,53,0.3)'}}
                    onClick={() => {
                      const S = { created:"รอชำระ", deposited:"รอจัดส่ง", shipped:"กำลังส่ง", released:"เสร็จสิ้น", disputed:"ข้อพิพาท", refunded:"คืนเงิน" };
                      const filtered = deals.filter(d => filterStatus === "ทั้งหมด" || d.status === filterStatus);
                      exportCSV(
                        `klang-deals-${new Date().toISOString().slice(0,10)}.csv`,
                        ["รหัสห้อง","สินค้า","ผู้ซื้อ","ผู้ขาย","มูลค่า (฿)","ค่าธรรมเนียม (฿)","สถานะ","วันที่"],
                        filtered.map(d => [
                          d.roomCode || d.id.slice(0,6).toUpperCase(),
                          d.itemName || "-",
                          d.buyerName || d.buyerId?.slice(0,8) || "-",
                          d.sellerName || d.sellerId?.slice(0,8) || "-",
                          d.price || 0,
                          d.platformFee || 0,
                          S[d.status] || d.status,
                          d.createdAt?.toDate ? d.createdAt.toDate().toLocaleDateString("th-TH") : "-",
                        ])
                      );
                    }}>
                    Export CSV
                  </button>
                </div>
              </div>
              <table className="data-table">
                <thead>
                  <tr>
                    <th>รหัสห้อง</th>
                    <th>สินค้า</th>
                    <th>ผู้ซื้อ</th>
                    <th>ผู้ขาย</th>
                    <th>มูลค่า</th>
                    <th>สถานะ</th>
                    <th>วันที่</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {deals
                    .filter(d => filterStatus === "ทั้งหมด" || d.status === filterStatus)
                    .filter(d => !search ||
                      (d.itemName||"").includes(search) ||
                      (d.roomCode||"").includes(search) ||
                      (d.buyerName||"").includes(search) ||
                      (d.sellerName||"").includes(search))
                    .map((d) => {
                      const STATUS_TH = { created:"รอชำระ", deposited:"รอจัดส่ง", shipped:"กำลังส่ง", completed:"เสร็จสิ้น", released:"เสร็จสิ้น", refunded:"คืนเงินแล้ว", disputed:"ข้อพิพาท" };
                      const STATUS_CLS = { created:"pending", deposited:"pending", shipped:"shipped", completed:"success", released:"success", refunded:"pending", disputed:"dispute" };
                      const dateStr = d.createdAt?.toDate ? d.createdAt.toDate().toLocaleDateString("th-TH",{day:"numeric",month:"short"}) : "-";
                      return (
                        <tr key={d.id}>
                          <td><span className="deal-id">{d.roomCode || d.id.slice(0,6).toUpperCase()}</span></td>
                          <td>{d.itemName || "-"}</td>
                          <td style={{ color: "#607caa" }}>{d.buyerName || d.buyerId?.slice(0,8) || "-"}</td>
                          <td style={{ color: "#dc3728" }}>{d.sellerName || d.sellerId?.slice(0,8) || "-"}</td>
                          <td style={{ fontWeight: 600 }}>฿{(d.price||0).toLocaleString()}</td>
                          <td>
                            <span className={`badge ${STATUS_CLS[d.status]||""}`}>
                              <span className="badge-dot-sm" />
                              {STATUS_TH[d.status] || d.status}
                            </span>
                          </td>
                          <td style={{ color: "#8a919e" }}>{dateStr}</td>
                          <td>
                            <button className="action-link"
                              onClick={() => navigate(`/chat/${d.id}?admin=true`)}>
                              ดูแชต →
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                  {deals.length === 0 && (
                    <tr><td colSpan={8} style={{textAlign:'center',color:'#8a919e',padding:24}}>ยังไม่มีดีล</td></tr>
                  )}
                </tbody>
              </table>
            </div>
          )}

          {/* ── Disputes ── */}
          {page === "disputes" && (
            <div className="table-card">
              <div className="table-header">
                <div className="table-title">
                  ข้อพิพาทที่รอตรวจสอบ ({disputes.length} เคส)
                </div>
              </div>
              <table className="data-table">
                <thead>
                  <tr>
                    <th>ห้อง</th>
                    <th>สินค้า</th>
                    <th>ผู้ซื้อ</th>
                    <th>ผู้ขาย</th>
                    <th>มูลค่า</th>
                    <th>ดำเนินการ</th>
                  </tr>
                </thead>
                <tbody>
                  {disputes.length === 0 && (
                    <tr><td colSpan={6} style={{textAlign:'center',color:'#8a919e',padding:24}}>ไม่มีข้อพิพาท</td></tr>
                  )}
                  {disputes.map((d) => (
                    <tr key={d.id}>
                      <td>
                        <span className="deal-id">{d.code || d.id.slice(0,6).toUpperCase()}</span>
                      </td>
                      <td>{d.itemName || "-"}</td>
                      <td style={{ color: "#607caa" }}>{d.buyerName || d.buyerId?.slice(0,8) || "-"}</td>
                      <td style={{ color: "#607caa" }}>{d.sellerName || d.sellerId?.slice(0,8) || "-"}</td>
                      <td style={{ fontWeight: 600, color: "#ff5555" }}>
                        ฿{(d.price || 0).toLocaleString()}
                      </td>
                      <td style={{ display: "flex", gap: 6 }}>
                        <button className="action-link"
                          onClick={() => navigate(`/chat/${d.id}?admin=true`)}>
                          ตรวจสอบ
                        </button>
                        <button className="action-link" style={{ color:"#dc3728" }}
                          onClick={async () => {
                            if (!window.confirm(`ปล่อยเงินให้ผู้ขาย "${d.sellerName||d.sellerId?.slice(0,8)}" ใช่ไหม?`)) return;
                            try {
                              await escrowReleaseFn({ roomId: d.id });
                              alert("ปล่อยเงินให้ผู้ขายแล้ว");
                            } catch(err) { alert("เกิดข้อผิดพลาด: " + err.message); }
                          }}>
                          ผู้ขายชนะ
                        </button>
                        <button className="action-link" style={{ color:"#ff5555" }}
                          onClick={async () => {
                            if (!window.confirm(`คืนเงิน ฿${(d.lockedAmount||d.price||0).toLocaleString()} ให้ผู้ซื้อ "${d.buyerName||d.buyerId?.slice(0,8)}" ใช่ไหม?`)) return;
                            try {
                              await escrowRefundFn({ roomId: d.id, reason: "แอดมินตัดสินข้อพิพาท — คืนเงินผู้ซื้อ" });
                              alert("คืนเงินให้ผู้ซื้อแล้ว");
                            } catch(err) { alert("เกิดข้อผิดพลาด: " + err.message); }
                          }}>
                          คืนเงิน
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {/* ── Finance ── */}
          {page === "finance" && (() => {
            const now = new Date();
            const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate());
            const monthStart = new Date(now.getFullYear(), now.getMonth(), 1);

            const toDate = (ts) => ts?.toDate ? ts.toDate() : (ts ? new Date(ts) : null);

            // รายได้วันนี้ = topup วันนี้
            const todayTopup = transactions
              .filter((t) => t.type === "topup" && toDate(t.createdAt) >= todayStart)
              .reduce((s, t) => s + (t.amount || 0), 0);

            // รายได้เดือนนี้ = topup เดือนนี้
            const monthTopup = transactions
              .filter((t) => t.type === "topup" && toDate(t.createdAt) >= monthStart)
              .reduce((s, t) => s + (t.amount || 0), 0);

            // เงินที่ถือใน Escrow = ดีลที่ status เป็น deposited หรือ shipped
            const escrow = deals
              .filter((d) => d.status === "deposited" || d.status === "shipped")
              .reduce((s, d) => s + (d.price || 0), 0);
            const escrowCount = deals.filter((d) => d.status === "deposited" || d.status === "shipped").length;

            // คืนเงินทั้งหมด
            const totalRefund = transactions
              .filter((t) => t.type === "refund")
              .reduce((s, t) => s + (t.amount || 0), 0);
            const refundCount = transactions.filter((t) => t.type === "refund").length;

            const TX_LABEL = {
              topup:   { label: "เติมเงิน",        cls: "success" },
              lock:    { label: "วางมัดจำ Escrow",  cls: "shipping" },
              release: { label: "โอนให้ผู้ขาย",     cls: "success" },
              refund:  { label: "คืนเงิน",          cls: "dispute" },
              withdraw:{ label: "ถอนเงิน",          cls: "dispute" },
            };

            const filteredTxs = transactions.filter((t) => {
              if (!search) return true;
              const s = search.toLowerCase();
              return (
                (t.type || "").includes(s) ||
                (t.userId || "").includes(s) ||
                (t.itemName || "").toLowerCase().includes(s)
              );
            });

            return (
              <>
                <div className="stats-grid">
                  <div className="stat-card">
                    <div className="stat-label">เติมเงินวันนี้</div>
                    <div className="stat-num">฿{todayTopup.toLocaleString()}</div>
                    <div className="stat-change up">{transactions.filter((t) => t.type === "topup" && toDate(t.createdAt) >= todayStart).length} รายการ</div>
                  </div>
                  <div className="stat-card">
                    <div className="stat-label">เติมเงินเดือนนี้</div>
                    <div className="stat-num">฿{monthTopup.toLocaleString()}</div>
                    <div className="stat-change up">{transactions.filter((t) => t.type === "topup" && toDate(t.createdAt) >= monthStart).length} รายการ</div>
                  </div>
                  <div className="stat-card info">
                    <div className="stat-label">เงินที่ถือ (Escrow)</div>
                    <div className="stat-num">฿{escrow.toLocaleString()}</div>
                    <div className="stat-change">{escrowCount} ดีลที่ active</div>
                  </div>
                  <div className="stat-card danger">
                    <div className="stat-label">คืนเงินทั้งหมด</div>
                    <div className="stat-num">฿{totalRefund.toLocaleString()}</div>
                    <div className="stat-change down">{refundCount} เคสที่ refund</div>
                  </div>
                </div>

                <div className="table-card">
                  <div className="table-header">
                    <div className="table-title">ธุรกรรมทั้งหมด ({transactions.length} รายการ)</div>
                    <div className="table-actions">
                      <button className="t-action" style={{color:'#dc3728',borderColor:'rgba(247,71,53,0.3)'}}
                        onClick={() => {
                          const TX_TH = { topup:"เติมเงิน", lock:"วางมัดจำ Escrow", release:"โอนให้ผู้ขาย", refund:"คืนเงิน", withdraw:"ถอนเงิน", withdraw_request:"ขอถอนเงิน" };
                          const toDate2 = (ts) => ts?.toDate ? ts.toDate() : (ts ? new Date(ts) : null);
                          exportCSV(
                            `klang-transactions-${new Date().toISOString().slice(0,10)}.csv`,
                            ["วันที่","ประเภท","ผู้ใช้","จำนวน (฿)","ค่าธรรมเนียม (฿)","ห้อง ID","สถานะ"],
                            transactions.map(tx => {
                              const d = toDate2(tx.createdAt);
                              const uData = users.find(u => u.id === tx.userId);
                              return [
                                d ? d.toLocaleDateString("th-TH",{day:"numeric",month:"short",year:"numeric"}) : "-",
                                TX_TH[tx.type] || tx.type,
                                uData?.name || uData?.displayName || tx.userId?.slice(0,10) || "-",
                                tx.amount || 0,
                                tx.fee || 0,
                                tx.roomId || "-",
                                tx.status || "-",
                              ];
                            })
                          );
                        }}>
                        Export CSV
                      </button>
                    </div>
                  </div>
                  <table className="data-table">
                    <thead>
                      <tr>
                        <th>วันที่/เวลา</th>
                        <th>ประเภท</th>
                        <th>ผู้ใช้</th>
                        <th>จำนวน</th>
                        <th>ค่าธรรมเนียม</th>
                        <th>สถานะ</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredTxs.length === 0 && (
                        <tr><td colSpan={6} style={{textAlign:"center",color:"#8a919e",padding:24}}>ยังไม่มีธุรกรรม</td></tr>
                      )}
                      {filteredTxs.slice(0, 50).map((tx) => {
                        const meta = TX_LABEL[tx.type] || { label: tx.type, cls: "pending" };
                        const d = toDate(tx.createdAt);
                        const dateStr = d ? d.toLocaleDateString("th-TH", { day:"numeric", month:"short", hour:"2-digit", minute:"2-digit" }) : "-";
                        const isNeg = tx.type === "refund" || tx.type === "withdraw" || tx.type === "lock";
                        // หา displayName จาก users
                        const uData = users.find((u) => u.id === tx.userId);
                        const uName = uData?.name || uData?.displayName || tx.userId?.slice(0, 10) || "-";
                        return (
                          <tr key={tx.id}>
                            <td style={{ color:"#8a919e", fontSize:"0.78rem" }}>{dateStr}</td>
                            <td><span className={`badge ${meta.cls}`}>{meta.label}</span></td>
                            <td style={{ color:"#8a919e", fontSize:"0.78rem" }}>{uName}</td>
                            <td style={{ fontWeight:600, color: isNeg ? "#ff5555" : "#dc3728" }}>
                              {isNeg ? "-" : "+"}฿{(tx.amount || 0).toLocaleString()}
                            </td>
                            <td style={{ color:"#8a919e" }}>
                              {tx.fee ? `฿${tx.fee.toLocaleString()}` : "-"}
                            </td>
                            <td>
                              <span className={`badge ${tx.status === "pending_verify" ? "pending" : "success"}`}>
                                {tx.status === "pending_verify" ? "รอตรวจสอบ" : "สำเร็จ"}
                              </span>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </>
            );
          })()}

          {/* ── Users ── */}
          {page === "users" && (() => {
            // นับดีลและมูลค่าต่อ user จาก deals ที่โหลดแล้ว
            const userStats = {};
            deals.forEach((d) => {
              [d.buyerId, d.sellerId].filter(Boolean).forEach((uid) => {
                if (!userStats[uid]) userStats[uid] = { count: 0, total: 0 };
                userStats[uid].count += 1;
                userStats[uid].total += d.price || 0;
              });
            });
            // คะแนนรีวิวเฉลี่ยต่อ user (revieweeId)
            const reviewStats = {};
            reviews.forEach((r) => {
              if (!r.revieweeId) return;
              if (!reviewStats[r.revieweeId]) reviewStats[r.revieweeId] = { sum: 0, count: 0 };
              reviewStats[r.revieweeId].sum   += r.stars || 0;
              reviewStats[r.revieweeId].count += 1;
            });

            const filtered = users.filter((u) => {
              if (!search) return true;
              const s = search.toLowerCase();
              return (
                (u.name || "").toLowerCase().includes(s) ||
                (u.email || "").toLowerCase().includes(s)
              );
            });

            return (
              <div className="table-card">
                <div className="table-header">
                  <div className="table-title">ผู้ใช้งานทั้งหมด ({users.length} คน)</div>
                </div>
                <table className="data-table">
                  <thead>
                    <tr>
                      <th>ผู้ใช้</th>
                      <th>อีเมล</th>
                      <th>ยอดกระเป๋า</th>
                      <th>ดีลทั้งหมด</th>
                      <th>มูลค่าดีลรวม</th>
                      <th>คะแนนรีวิว</th>
                      <th>สถานะ</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {filtered.length === 0 && (
                      <tr><td colSpan={8} style={{textAlign:"center",color:"#8a919e",padding:24}}>ไม่พบผู้ใช้</td></tr>
                    )}
                    {filtered.map((u) => {
                      const stat   = userStats[u.id]  || { count: 0, total: 0 };
                      const revStat = reviewStats[u.id] || { sum: 0, count: 0 };
                      const avgRating = revStat.count > 0 ? (revStat.sum / revStat.count).toFixed(1) : null;
                      const uName = u.name || u.displayName || u.email?.split("@")[0] || "ไม่ระบุ";
                      const isSuspended = u.suspended === true;
                      const isAdmin = u.isAdmin === true;
                      return (
                        <tr key={u.id}>
                          <td style={{ display:"flex", alignItems:"center", gap:10 }}>
                            <div className="avatar-sm" style={{ background:"linear-gradient(135deg,#1a3a25,#2a5a35)", color:"#dc3728" }}>
                              {uName[0]?.toUpperCase()}
                            </div>
                            <div>
                              <div>{uName}</div>
                              {isAdmin && <div style={{ fontSize:"0.65rem", color:"#c77b27" }}>Admin</div>}
                            </div>
                          </td>
                          <td style={{ color:"#8a919e" }}>{u.email || "-"}</td>
                          <td style={{ color:"#dc3728", fontWeight:600 }}>
                            ฿{(u.wallet_balance || 0).toLocaleString()}
                          </td>
                          <td>{stat.count}</td>
                          <td style={{ color:"#dc3728", fontWeight:600 }}>
                            ฿{stat.total.toLocaleString()}
                          </td>
                          <td>
                            {avgRating
                              ? <span style={{color:'#ffcc00',fontWeight:600}}><Icon name="star-fill" size={13} /> {avgRating} <span style={{color:'#8a919e',fontWeight:400,fontSize:'0.72rem'}}>({revStat.count})</span></span>
                              : <span style={{color:'#8a919e',fontSize:'0.75rem'}}>-</span>
                            }
                          </td>
                          <td>
                            <span className={`badge ${isSuspended ? "dispute" : "success"}`}>
                              {isSuspended ? "ถูกระงับ" : "ใช้งานได้"}
                            </span>
                          </td>
                          <td>
                            <button
                              className="action-link"
                              style={{ color: isSuspended ? "#dc3728" : "#ff5555" }}
                              onClick={async () => {
                                await updateDoc(doc(db, "users", u.id), {
                                  suspended: !isSuspended,
                                });
                              }}
                            >
                              {isSuspended ? "ปลดระงับ" : "ระงับ"}
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            );
          })()}
          {/* ── Coupons ── */}
          {page === "coupons" && (() => {
            const nameOfUid = (uid) => {
              const u = users.find((x) => x.id === uid);
              return u ? (u.name || u.email || uid) : "(ไม่พบผู้ใช้)";
            };
            const editOwner = async (c) => {
              const current = users.find((x) => x.id === c.ownerId)?.email || "";
              const email = window.prompt(`เจ้าของคูปอง "${c.code}" (อีเมล)`, current);
              if (email === null) return;
              const owner = findUserByEmail(email);
              if (!owner) { alert("ไม่พบสมาชิกอีเมลนี้ในระบบ"); return; }
              const pctInput = window.prompt(`ส่วนแบ่งของเจ้าของ (% ของค่าธรรมเนียม, 0-100)`, String(c.ownerSharePercent ?? 0));
              if (pctInput === null) return;
              const pct = Number(pctInput);
              if (!Number.isFinite(pct) || pct < 0 || pct > 100) { alert("ส่วนแบ่งต้องเป็นตัวเลข 0-100"); return; }
              await updateDoc(doc(db, "coupons", c.id), { ownerId: owner.id, ownerSharePercent: pct });
              if (owner.id !== c.ownerId || pct !== c.ownerSharePercent) notifyCouponOwner(owner.id, c.code, pct);
            };
            // ส่วนแบ่งที่เจ้าของได้รับแล้วต่อคูปอง (รวมจากรายการปล่อยเงินที่ใช้คูปองนั้น)
            const shareEarned = {};
            transactions.forEach((t) => {
              if (t.type === "release" && t.couponShare > 0 && t.couponCode) {
                shareEarned[t.couponCode] = (shareEarned[t.couponCode] || 0) + t.couponShare;
              }
            });
            const generalCoupons = coupons.filter((c) => !c.ownerId);
            const memberCoupons  = coupons.filter((c) => !!c.ownerId);

            const renderCouponTable = (list, member) => list.length === 0 ? (
              <div style={{textAlign:"center",color:"#8a919e",padding:"32px 20px",fontSize:"0.85rem"}}>
                {member ? "ยังไม่มีคูปองของสมาชิก — เลือก “คูปองของสมาชิก” ในฟอร์มด้านซ้ายเพื่อสร้าง" : "ยังไม่มีคูปอง — สร้างคูปองแรกได้เลย"}
              </div>
            ) : (
              <table className="data-table">
                <thead>
                  <tr>
                    <th>รหัส</th>
                    <th>ประเภท / ค่า</th>
                    <th>เงื่อนไข</th>
                    {member && <th>เจ้าของ / ส่วนแบ่ง</th>}
                    <th>การใช้งาน</th>
                    <th>หมดอายุ</th>
                    <th>สถานะ</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {list.map((c) => {
                    const isExpired = c.expiresAt && c.expiresAt.toDate() < new Date();
                    const isFull    = c.maxUses && c.usedCount >= c.maxUses;
                    const usagePct  = c.maxUses ? Math.round((c.usedCount / c.maxUses) * 100) : 0;
                    const canUse    = c.isActive && !isExpired && !isFull;
                    return (
                      <tr key={c.id}>
                        <td><span className="coupon-code-badge">{c.code}</span></td>
                        <td>
                          <span className="badge success">
                            {c.type === "percent"
                              ? `${c.value}%${c.maxDiscount ? ` (max ฿${c.maxDiscount})` : ""}`
                              : `฿${c.value.toLocaleString()}`}
                          </span>
                        </td>
                        <td style={{fontSize:"0.75rem",color:"#8a919e"}}>
                          {c.minPrice ? `ขั้นต่ำ ฿${c.minPrice.toLocaleString()}` : "ไม่จำกัด"}
                        </td>
                        {member && (
                          <td style={{fontSize:"0.74rem"}}>
                            <div style={{fontWeight:600}}>{nameOfUid(c.ownerId)}</div>
                            <div style={{color:"#8a919e"}}>{users.find((x) => x.id === c.ownerId)?.email || ""}</div>
                            <div style={{color:"#dc3728",fontWeight:600}}>
                              ส่วนแบ่ง {c.ownerSharePercent ?? 0}% · ได้แล้ว ฿{(shareEarned[c.code] || 0).toLocaleString()}
                            </div>
                            <button className="action-link" style={{padding:0,fontSize:"0.72rem"}} onClick={() => editOwner(c)}>แก้เจ้าของ/ส่วนแบ่ง</button>
                          </td>
                        )}
                        <td>
                          <div className="coupon-usage">{c.usedCount}/{c.maxUses ?? "∞"}</div>
                          {c.maxUses && (
                            <div className="coupon-progress">
                              <div className="coupon-progress-bar"
                                style={{width:`${usagePct}%`, background: usagePct >= 90 ? "#ff5555" : "#dc3728"}} />
                            </div>
                          )}
                        </td>
                        <td style={{fontSize:"0.75rem",color: isExpired ? "#ff5555" : "#8a919e"}}>
                          {c.expiresAt
                            ? c.expiresAt.toDate().toLocaleDateString("th-TH",{day:"numeric",month:"short",year:"2-digit"})
                            : "ไม่มี"}
                          
                        </td>
                        <td>
                          <span className={`badge ${canUse ? "success" : "dispute"}`}>
                            {isExpired ? "หมดอายุ" : isFull ? "ใช้ครบแล้ว" : c.isActive ? "ใช้งานได้" : "ปิดใช้"}
                          </span>
                        </td>
                        <td style={{display:"flex",gap:6,alignItems:"center",flexWrap:"wrap"}}>
                          <button
                            className={`toggle-btn ${c.isActive ? "on" : "off"}`}
                            onClick={() => updateDoc(doc(db,"coupons",c.id),{ isActive: !c.isActive })}
                          >
                            {c.isActive ? "เปิด" : "ปิด"}
                          </button>
                          <button
                            className="action-link"
                            style={{color:"#c77b27",fontSize:"0.72rem"}}
                            title="รีเซ็ตจำนวนการใช้งานกลับเป็น 0"
                            onClick={async () => {
                              if (!window.confirm(`รีเซ็ตการใช้งานของ "${c.code}" กลับเป็น 0?`)) return;
                              await updateDoc(doc(db,"coupons",c.id),{ usedCount: 0, usedBy: [] });
                            }}
                          >
                            รีเซ็ต
                          </button>
                          <button
                            className="action-link"
                            style={{color:"#ff5555"}}
                            onClick={async () => {
                              if (!window.confirm(`ลบคูปอง "${c.code}" ?`)) return;
                              await deleteDoc(doc(db,"coupons",c.id));
                            }}
                          >
                            ลบ
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            );

            return (
            <div className="coupon-grid">

              {/* ── ฟอร์มสร้างคูปอง ── */}
              <div className="coupon-form-card">
                <div className="coupon-form-title">สร้างคูปองใหม่</div>
                {cfErr && <div className="cf-err">{cfErr}</div>}
                {cfOk  && <div className="cf-ok">{cfOk}</div>}
                <form onSubmit={handleCreateCoupon}>
                  <div className="cf-group">
                    <label className="cf-label">รหัสคูปอง *</label>
                    <input className="cf-input" placeholder="เช่น TRADE50, NEWUSER"
                      value={cfCode}
                      onChange={(e) => setCfCode(e.target.value.toUpperCase())}
                      maxLength={20} />
                  </div>

                  <div className="cf-group">
                    <label className="cf-label">คูปองนี้สำหรับ *</label>
                    <div className="cf-type-btns">
                      <button type="button" className={`cf-type-btn${cfAudience === "all" ? " active" : ""}`}
                        onClick={() => setCfAudience("all")}>คูปองทั่วไป</button>
                      <button type="button" className={`cf-type-btn${cfAudience === "members" ? " active" : ""}`}
                        onClick={() => setCfAudience("members")}>คูปองของสมาชิก (มีส่วนแบ่ง)</button>
                    </div>
                  </div>

                  {cfAudience === "members" && (
                    <>
                      <div className="cf-group">
                        <label className="cf-label">อีเมลเจ้าของคูปอง (สมาชิก) *</label>
                        <input className="cf-input" placeholder="เช่น member@gmail.com"
                          value={cfOwnerEmail} onChange={(e) => setCfOwnerEmail(e.target.value)} />
                      </div>
                      <div className="cf-group">
                        <label className="cf-label">ส่วนแบ่งของเจ้าของคูปอง (%) *</label>
                        <input className="cf-input" type="number" min="0" max="100"
                          placeholder="เช่น 20"
                          value={cfSharePct} onChange={(e) => setCfSharePct(e.target.value)} />
                        <div style={{fontSize:"0.7rem",color:"#8a919e",marginTop:4}}>
                          ใครก็กรอกรหัสนี้ลดค่าธรรมเนียมได้ — เมื่อดีลที่ใช้คูปองนี้สำเร็จ เจ้าของได้ส่วนแบ่ง % ของค่าธรรมเนียมที่เก็บจริง (หลังหักส่วนลดแล้ว) เข้ากระเป๋าอัตโนมัติ
                          {cfSharePct !== "" && Number(cfSharePct) >= 0 && Number(cfSharePct) <= 100 && (
                            <> — ตัวอย่าง ค่าธรรมเนียม ฿50 ได้ ฿{Math.round(50 * Number(cfSharePct) / 100)} ต่อดีล</>
                          )}
                        </div>
                      </div>
                    </>
                  )}

                  <div className="cf-group">
                    <label className="cf-label">ประเภทส่วนลด *</label>
                    <div className="cf-type-btns">
                      <button type="button" className={`cf-type-btn${cfType === "percent" ? " active" : ""}`}
                        onClick={() => setCfType("percent")}>% เปอร์เซ็นต์</button>
                      <button type="button" className={`cf-type-btn${cfType === "flat" ? " active" : ""}`}
                        onClick={() => setCfType("flat")}>฿ จำนวนบาท</button>
                    </div>
                  </div>

                  <div className="cf-row">
                    <div className="cf-group">
                      <label className="cf-label">
                        {cfType === "percent" ? "ลดกี่ % *" : "ลดกี่บาท (฿) *"}
                      </label>
                      <input className="cf-input" type="number" min="1"
                        max={cfType === "percent" ? 100 : undefined}
                        placeholder={cfType === "percent" ? "เช่น 50" : "เช่น 100"}
                        value={cfValue} onChange={(e) => setCfValue(e.target.value)} />
                    </div>
                    {cfType === "percent" && (
                      <div className="cf-group">
                        <label className="cf-label">ลดสูงสุด (฿)</label>
                        <input className="cf-input" type="number" min="1"
                          placeholder="เช่น 200 (ว่าง = ไม่จำกัด)"
                          value={cfMaxDiscount} onChange={(e) => setCfMaxDiscount(e.target.value)} />
                      </div>
                    )}
                  </div>

                  <div className="cf-row">
                    <div className="cf-group">
                      <label className="cf-label">จำนวนครั้งที่ใช้ได้</label>
                      <input className="cf-input" type="number" min="1"
                        placeholder="ว่าง = ไม่จำกัด"
                        value={cfMaxUses} onChange={(e) => setCfMaxUses(e.target.value)} />
                    </div>
                    <div className="cf-group">
                      <label className="cf-label">ราคาสินค้าขั้นต่ำ (฿)</label>
                      <input className="cf-input" type="number" min="0"
                        placeholder="ว่าง = ไม่จำกัด"
                        value={cfMinPrice} onChange={(e) => setCfMinPrice(e.target.value)} />
                    </div>
                  </div>

                  <div className="cf-group">
                    <label className="cf-label">วันหมดอายุ</label>
                    <input className="cf-input" type="datetime-local"
                      value={cfExpires} onChange={(e) => setCfExpires(e.target.value)} />
                  </div>

                  {/* Preview */}
                  {cfCode && cfValue && (
                    <div style={{background:"rgba(247,71,53,0.05)",border:"1px solid rgba(247,71,53,0.2)",borderRadius:8,padding:"10px 12px",marginBottom:12,fontSize:"0.78rem",color:"#8a919e"}}>
                      <div style={{color:"#dc3728",fontWeight:700,marginBottom:4}}>Preview</div>
                      <div>รหัส: <strong style={{color:"#242b36"}}>{cfCode.toUpperCase()}</strong></div>
                      <div>ส่วนลด: {cfType === "percent"
                        ? `${cfValue}%${cfMaxDiscount ? ` (สูงสุด ฿${cfMaxDiscount})` : ""}`
                        : `฿${Number(cfValue).toLocaleString()}`}
                      </div>
                      {cfMaxUses && <div>ใช้ได้: {cfMaxUses} ครั้ง</div>}
                      {cfMinPrice && <div>ราคาขั้นต่ำ: ฿{Number(cfMinPrice).toLocaleString()}</div>}
                      {cfExpires && <div>หมดอายุ: {new Date(cfExpires).toLocaleDateString("th-TH")}</div>}
                      {cfAudience === "members" && <div>เจ้าของ: {cfOwnerEmail || "—"} · ส่วนแบ่ง {cfSharePct || 0}%</div>}
                    </div>
                  )}

                  <button type="submit" className="cf-submit" disabled={cfLoading}>
                    {cfLoading ? "กำลังสร้าง..." : "➕ สร้างคูปอง"}
                  </button>
                </form>
              </div>

              {/* ── รายการคูปอง: ทั่วไป + ของสมาชิก ── */}
              <div style={{ display: "flex", flexDirection: "column", gap: 16, minWidth: 0 }}>
                <div className="table-card">
                  <div className="table-header">
                    <div className="table-title">คูปองทั่วไป ({generalCoupons.length})</div>
                  </div>
                  {renderCouponTable(generalCoupons, false)}
                </div>
                <div className="table-card">
                  <div className="table-header">
                    <div className="table-title">คูปองของสมาชิก ({memberCoupons.length})</div>
                  </div>
                  {renderCouponTable(memberCoupons, true)}
                </div>
              </div>

            </div>
            );
          })()}

          {/* ── Withdrawals ── */}
          {page === "withdrawals" && (() => {
            const pending  = withdrawals.filter(w => w.status === "pending");
            const approved = withdrawals.filter(w => w.status === "approved");
            const rejected = withdrawals.filter(w => w.status === "rejected");
            return (
              <>
                <div className="stats-grid" style={{ marginBottom:20 }}>
                  <div className="stat-card warning">
                    <div className="stat-label">รอดำเนินการ</div>
                    <div className="stat-num">{pending.length}</div>
                    <div className="stat-change">คำขอที่รอ Admin</div>
                  </div>
                  <div className="stat-card">
                    <div className="stat-label">อนุมัติแล้ว</div>
                    <div className="stat-num">{approved.length}</div>
                    <div className="stat-change up">฿{approved.reduce((s,w)=>s+(w.amount||0),0).toLocaleString()}</div>
                  </div>
                  <div className="stat-card danger">
                    <div className="stat-label">ปฏิเสธ</div>
                    <div className="stat-num">{rejected.length}</div>
                    <div className="stat-change">&nbsp;</div>
                  </div>
                  <div className="stat-card info">
                    <div className="stat-label">รวมทั้งหมด</div>
                    <div className="stat-num">{withdrawals.length}</div>
                    <div className="stat-change">฿{withdrawals.filter(w=>w.status==="approved").reduce((s,w)=>s+(w.amount||0),0).toLocaleString()} โอนแล้ว</div>
                  </div>
                </div>

                <div className="table-card">
                  <div className="table-header">
                    <div className="table-title">คำขอถอนเงินทั้งหมด ({withdrawals.length})</div>
                    <div className="table-actions">
                      {["ทั้งหมด","pending","approved","rejected"].map(f => (
                        <button key={f} className="t-action"
                          style={filterStatus===f?{background:"rgba(247,71,53,0.15)",color:"#dc3728",border:"1px solid rgba(247,71,53,0.3)"}:{}}
                          onClick={() => setFilterStatus(f)}>
                          {f==="ทั้งหมด"?"ทั้งหมด":f==="pending"?"รอดำเนินการ":f==="approved"?"อนุมัติแล้ว":"ปฏิเสธ"}
                        </button>
                      ))}
                      <button className="t-action" style={{color:"#dc3728",borderColor:"rgba(247,71,53,0.3)"}}
                        onClick={() => {
                          const toD = (ts) => ts?.toDate ? ts.toDate() : (ts ? new Date(ts) : null);
                          exportCSV(
                            `klang-withdrawals-${new Date().toISOString().slice(0,10)}.csv`,
                            ["วันที่ขอ","ชื่อ","ธนาคาร","เลขบัญชี","ชื่อบัญชี","จำนวน (฿)","สถานะ","วันที่อนุมัติ","เลขอ้างอิง","เหตุผลปฏิเสธ"],
                            withdrawals.map(w => {
                              const uData = users.find(u => u.id === w.uid);
                              const uName = uData?.name || uData?.email?.split("@")[0] || w.uid?.slice(0,8) || "-";
                              const d = toD(w.createdAt);
                              const ad = toD(w.approvedAt);
                              return [
                                d ? d.toLocaleDateString("th-TH",{day:"numeric",month:"short",year:"numeric",hour:"2-digit",minute:"2-digit"}) : "-",
                                uName, w.bankName||"-", w.accountNumber||"-", w.accountName||"-",
                                w.amount||0,
                                w.status==="pending"?"รอดำเนินการ":w.status==="approved"?"อนุมัติแล้ว":"ปฏิเสธ",
                                ad ? ad.toLocaleDateString("th-TH",{day:"numeric",month:"short",year:"numeric",hour:"2-digit",minute:"2-digit"}) : "-",
                                w.transferRef||"-", w.rejectNote||"-",
                              ];
                            })
                          );
                        }}>Export CSV</button>
                    </div>
                  </div>
                  <table className="data-table">
                    <thead>
                      <tr>
                        <th>วันที่</th>
                        <th>ผู้ใช้</th>
                        <th>ธนาคาร / เลขบัญชี</th>
                        <th>จำนวน</th>
                        <th>สถานะ</th>
                        <th>ดำเนินการ</th>
                      </tr>
                    </thead>
                    <tbody>
                      {withdrawals
                        .filter(w => filterStatus === "ทั้งหมด" || w.status === filterStatus)
                        .map(w => {
                          const uData   = users.find(u => u.id === w.uid);
                          const uName   = uData?.name || uData?.email?.split("@")[0] || w.uid?.slice(0,8) || "-";
                          const dateStr = w.createdAt?.toDate ? w.createdAt.toDate().toLocaleDateString("th-TH",{day:"numeric",month:"short",hour:"2-digit",minute:"2-digit"}) : "-";
                          const appDateStr = w.approvedAt?.toDate ? w.approvedAt.toDate().toLocaleDateString("th-TH",{day:"numeric",month:"short",hour:"2-digit",minute:"2-digit"}) : null;
                          const copyKey = `${w.id}-acc`;
                          return (
                            <tr key={w.id}>
                              <td style={{ color:"#8a919e", fontSize:"0.78rem" }}>{dateStr}</td>
                              <td>{uName}</td>
                              <td>
                                <div className="wd-bank">{w.bankName}</div>
                                <div style={{ display:"flex", alignItems:"center", gap:6, marginTop:3 }}>
                                  <span className="wd-acc">{w.accountNumber} · {w.accountName}</span>
                                  <button
                                    className={`copy-btn${copiedId===copyKey?" copied":""}`}
                                    onClick={() => {
                                      navigator.clipboard.writeText(w.accountNumber||"").then(() => {
                                        setCopiedId(copyKey);
                                        setTimeout(() => setCopiedId(null), 2000);
                                      });
                                    }}>
                                    {copiedId===copyKey ? "✓ copied" : "copy"}
                                  </button>
                                </div>
                              </td>
                              <td style={{ color:"#c77b27", fontWeight:700 }}>฿{(w.amount||0).toLocaleString()}</td>
                              <td>
                                <span className={`badge ${w.status==="pending"?"pending":w.status==="approved"?"success":"dispute"}`}>
                                  {w.status==="pending"?"รอดำเนินการ":w.status==="approved"?"อนุมัติแล้ว":"ปฏิเสธ"}
                                </span>
                              </td>
                              <td>
                                {w.status === "pending" ? (
                                  <div style={{ display:"flex", flexDirection:"column", gap:6 }}>
                                    <div style={{ display:"flex", gap:6, alignItems:"center", flexWrap:"wrap" }}>
                                      <input className="wd-ref-input" placeholder="เลข Ref โอนเงิน (ถ้ามี)"
                                        value={approveRefs[w.id]||""} onChange={e => setApproveRefs(p=>({...p,[w.id]:e.target.value}))} />
                                      <button className="action-link" style={{ color:"#dc3728" }}
                                        onClick={async () => {
                                          if (!window.confirm(`อนุมัติถอน ฿${w.amount.toLocaleString()} ให้ ${uName}?\n\nโอนแล้วหรือยัง? ยืนยันเพื่ออัพเดทสถานะ`)) return;
                                          try { await withdrawApproveFn({ withdrawId: w.id, transferRef: approveRefs[w.id]||"" }); }
                                          catch(err) { alert(err.message); }
                                        }}>อนุมัติโอนแล้ว</button>
                                    </div>
                                    <div style={{ display:"flex", gap:6, alignItems:"center", flexWrap:"wrap" }}>
                                      <input className="wd-reject-input" placeholder="เหตุผลปฏิเสธ"
                                        value={rejectNotes[w.id]||""} onChange={e => setRejectNotes(p=>({...p,[w.id]:e.target.value}))} />
                                      <button className="action-link" style={{ color:"#ff5555" }}
                                        onClick={async () => {
                                          if (!window.confirm(`ปฏิเสธถอน ฿${w.amount.toLocaleString()} และคืนเงินให้ ${uName}?`)) return;
                                          try { await withdrawRejectFn({ withdrawId: w.id, note: rejectNotes[w.id]||"" }); }
                                          catch(err) { alert(err.message); }
                                        }}>ปฏิเสธ</button>
                                    </div>
                                  </div>
                                ) : (
                                  <div className="wd-approved-info">
                                    {w.status==="approved" ? (
                                      <>
                                        <div>โอนแล้ว {appDateStr && <span style={{color:"#8a919e"}}>· {appDateStr}</span>}</div>
                                        {w.transferRef && <div>Ref: <strong>{w.transferRef}</strong></div>}
                                      </>
                                    ) : (
                                      <div>เหตุผล: {w.rejectNote||"-"}</div>
                                    )}
                                  </div>
                                )}
                              </td>
                            </tr>
                          );
                        })}
                      {withdrawals.length === 0 && (
                        <tr><td colSpan={6} style={{ textAlign:"center", color:"#8a919e", padding:24 }}>ยังไม่มีคำขอถอนเงิน</td></tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </>
            );
          })()}

          {/* ── Reviews ── */}
          {page === "reviews" && (() => {
            const totalReviews = reviews.length;
            const avgOverall   = totalReviews > 0
              ? (reviews.reduce((s, r) => s + (r.stars || 0), 0) / totalReviews).toFixed(2)
              : "0.00";
            const dist = [5,4,3,2,1].map(s => ({ s, cnt: reviews.filter(r => r.stars === s).length }));
            const filteredRev = reviews.filter(r => {
              if (!search) return true;
              const q = search.toLowerCase();
              return (r.reviewerName||"").toLowerCase().includes(q) ||
                     (r.revieweeName||"").toLowerCase().includes(q) ||
                     (r.itemName||"").toLowerCase().includes(q) ||
                     (r.comment||"").toLowerCase().includes(q);
            });
            return (
              <>
                <div className="stats-grid" style={{ marginBottom:20 }}>
                  <div className="stat-card">
                    <div className="stat-label">รีวิวทั้งหมด</div>
                    <div className="stat-num" style={{color:'#ffcc00'}}>{totalReviews}</div>
                    <div className="stat-change">รายการรีวิว</div>
                  </div>
                  <div className="stat-card">
                    <div className="stat-label">คะแนนเฉลี่ย</div>
                    <div className="stat-num" style={{color:'#ffcc00'}}><Icon name="star-fill" size={16} /> {avgOverall}</div>
                    <div className="stat-change">จาก 5 ดาว</div>
                  </div>
                  {dist.slice(0,2).map(({ s, cnt }) => (
                    <div key={s} className="stat-card">
                      <div className="stat-label">{s} ดาว</div>
                      <div className="stat-num" style={{color:'#ffcc00'}}>{cnt}</div>
                      <div className="stat-change">{totalReviews > 0 ? Math.round(cnt/totalReviews*100) : 0}%</div>
                    </div>
                  ))}
                </div>

                {/* Star distribution bar */}
                <div className="table-card" style={{marginBottom:20}}>
                  <div className="table-header"><div className="table-title">การกระจายคะแนน</div></div>
                  <div style={{padding:'16px 20px'}}>
                    {dist.map(({ s, cnt }) => (
                      <div key={s} style={{display:'flex',alignItems:'center',gap:12,marginBottom:10}}>
                        <span style={{color:'#ffcc00',fontSize:'0.82rem',width:40,flexShrink:0}}>{s} <Icon name="star-fill" size={13} /></span>
                        <div style={{flex:1,height:8,background:'rgba(255,255,255,0.06)',borderRadius:4,overflow:'hidden'}}>
                          <div style={{height:8,borderRadius:4,background:'#ffcc00',width:`${totalReviews>0?Math.round(cnt/totalReviews*100):0}%`,transition:'width 0.3s'}}/>
                        </div>
                        <span style={{color:'#8a919e',fontSize:'0.78rem',width:50,textAlign:'right',flexShrink:0}}>{cnt} รายการ</span>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Reviews table */}
                <div className="table-card">
                  <div className="table-header">
                    <div className="table-title">รายการรีวิวทั้งหมด ({totalReviews})</div>
                    <div className="table-actions">
                      <button className="t-action" style={{color:'#dc3728',borderColor:'rgba(247,71,53,0.3)'}}
                        onClick={() => {
                          exportCSV(
                            `klang-reviews-${new Date().toISOString().slice(0,10)}.csv`,
                            ["วันที่","ผู้รีวิว","ผู้ถูกรีวิว","สินค้า","บทบาท","ดาว","ความคิดเห็น"],
                            reviews.map(r => [
                              r.createdAt?.toDate ? r.createdAt.toDate().toLocaleDateString("th-TH") : "-",
                              r.reviewerName || "-",
                              r.revieweeName || "-",
                              r.itemName || "-",
                              r.role === "buyer" ? "ผู้ซื้อ" : "ผู้ขาย",
                              r.stars || 0,
                              r.comment || "",
                            ])
                          );
                        }}>Export CSV</button>
                    </div>
                  </div>
                  <table className="data-table">
                    <thead>
                      <tr>
                        <th>ผู้รีวิว</th>
                        <th>ผู้ถูกรีวิว</th>
                        <th>สินค้า</th>
                        <th>คะแนน</th>
                        <th>ความคิดเห็น</th>
                        <th>วันที่</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredRev.length === 0 && (
                        <tr><td colSpan={6} style={{textAlign:'center',color:'#8a919e',padding:24}}>ยังไม่มีรีวิว</td></tr>
                      )}
                      {filteredRev.slice(0,50).map((r) => {
                        const d = r.createdAt?.toDate ? r.createdAt.toDate() : null;
                        const dateStr = d ? d.toLocaleDateString("th-TH",{day:"numeric",month:"short"}) : "-";
                        return (
                          <tr key={r.id}>
                            <td style={{color:'#607caa'}}>{r.reviewerName || "-"}</td>
                            <td style={{color:'#dc3728'}}>{r.revieweeName || "-"}</td>
                            <td style={{maxWidth:120,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{r.itemName || "-"}</td>
                            <td style={{color:'#ffcc00',fontWeight:700}}>{"★".repeat(r.stars||0)}{"☆".repeat(5-(r.stars||0))}</td>
                            <td style={{color:'#8a919e',maxWidth:180,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{r.comment || <em>ไม่มีความคิดเห็น</em>}</td>
                            <td style={{color:'#8a919e',fontSize:'0.78rem'}}>{dateStr}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </>
            );
          })()}

          {/* ── Topup Requests ── */}
          {page === "topups" && (() => {
            const pending  = topupRequests.filter(t => t.status === "pending");
            const approved = topupRequests.filter(t => t.status === "approved");
            const rejected = topupRequests.filter(t => t.status === "rejected");
            return (
              <>
                <div className="stats-grid" style={{ marginBottom:20 }}>
                  <div className="stat-card warning">
                    <div className="stat-label">รอตรวจสลิป</div>
                    <div className="stat-num">{pending.length}</div>
                    <div className="stat-change">รายการที่รอ Admin</div>
                  </div>
                  <div className="stat-card">
                    <div className="stat-label">อนุมัติแล้ว</div>
                    <div className="stat-num">{approved.length}</div>
                    <div className="stat-change up">฿{approved.reduce((s,t)=>s+(t.amount||0),0).toLocaleString()}</div>
                  </div>
                  <div className="stat-card danger">
                    <div className="stat-label">ปฏิเสธ</div>
                    <div className="stat-num">{rejected.length}</div>
                    <div className="stat-change">&nbsp;</div>
                  </div>
                  <div className="stat-card info">
                    <div className="stat-label">รวมทั้งหมด</div>
                    <div className="stat-num">{topupRequests.length}</div>
                    <div className="stat-change">฿{approved.reduce((s,t)=>s+(t.amount||0),0).toLocaleString()} เติมแล้ว</div>
                  </div>
                </div>

                <div className="table-card">
                  <div className="table-header">
                    <div className="table-title">คำขอแจ้งโอนทั้งหมด ({topupRequests.length})</div>
                  </div>
                  <table className="data-table">
                    <thead>
                      <tr>
                        <th>วันที่</th>
                        <th>ผู้ใช้</th>
                        <th>จำนวน</th>
                        <th>สลิป</th>
                        <th>สถานะ</th>
                        <th>ดำเนินการ</th>
                      </tr>
                    </thead>
                    <tbody>
                      {topupRequests.map(t => {
                        const uData = users.find(u => u.id === t.uid);
                        const uName = uData?.name || uData?.email?.split("@")[0] || t.uid?.slice(0,8) || "-";
                        const dateStr = t.createdAt?.toDate
                          ? t.createdAt.toDate().toLocaleDateString("th-TH",{day:"numeric",month:"short",hour:"2-digit",minute:"2-digit"})
                          : "-";
                        return (
                          <tr key={t.id}>
                            <td style={{ color:"#8a919e", fontSize:"0.78rem" }}>{dateStr}</td>
                            <td>{uName}</td>
                            <td style={{ color:"#dc3728", fontWeight:700 }}>฿{(t.amount||0).toLocaleString()}</td>
                            <td>
                              {(t.slipBase64 || t.slipUrl)
                                ? <button onClick={() => setSlipModal(t.slipBase64 || t.slipUrl)}
                                    style={{ background:"rgba(85,153,255,0.1)", border:"1px solid rgba(85,153,255,0.3)", color:"#5599ff", borderRadius:8, padding:"4px 10px", fontSize:"0.78rem", cursor:"pointer", fontFamily:"Prompt,sans-serif" }}>
                                    ดูสลิป
                                  </button>
                                : <span style={{ color:"#8a919e" }}>-</span>}
                            </td>
                            <td>
                              <span className={`badge ${t.status==="pending"?"pending":t.status==="approved"?"success":"dispute"}`}>
                                {t.status==="pending"?"รอตรวจ":t.status==="approved"?"อนุมัติแล้ว":"ปฏิเสธ"}
                              </span>
                            </td>
                            <td>
                              {t.status === "pending" ? (
                                <div style={{ display:"flex", flexDirection:"column", gap:6 }}>
                                  <button className="action-link" style={{ color:"#dc3728" }}
                                    onClick={() => setConfirmModal({
                                      message: `อนุมัติเติมเงิน ฿${t.amount.toLocaleString()} ให้ ${uName}?`,
                                      onConfirm: async () => {
                                        try { await topupApproveFn({ requestId: t.id }); }
                                        catch(err) { alert(err.message); }
                                      }
                                    })}>อนุมัติ</button>
                                  <div style={{ display:"flex", gap:6, alignItems:"center", flexWrap:"wrap" }}>
                                    <input className="wd-reject-input" placeholder="เหตุผลปฏิเสธ"
                                      value={topupRejectNotes[t.id]||""}
                                      onChange={e => setTopupRejectNotes(p=>({...p,[t.id]:e.target.value}))} />
                                    <button className="action-link" style={{ color:"#ff5555" }}
                                      onClick={() => setConfirmModal({
                                        message: `ปฏิเสธคำขอเติมเงิน ฿${t.amount.toLocaleString()} ของ ${uName}?`,
                                        onConfirm: async () => {
                                          try { await topupRejectFn({ requestId: t.id, note: topupRejectNotes[t.id]||"" }); }
                                          catch(err) { alert(err.message); }
                                        }
                                      })}>ปฏิเสธ</button>
                                  </div>
                                </div>
                              ) : (
                                <span style={{ color:"#8a919e", fontSize:"0.8rem" }}>
                                  {t.status==="approved" ? `${t.approvedAt?.toDate?.()?.toLocaleDateString("th-TH",{day:"numeric",month:"short",hour:"2-digit",minute:"2-digit"})||""}` : `${t.rejectNote||"-"}`}
                                </span>
                              )}
                            </td>
                          </tr>
                        );
                      })}
                      {topupRequests.length === 0 && (
                        <tr><td colSpan={6} style={{ textAlign:"center", color:"#8a919e", padding:24 }}>ยังไม่มีคำขอแจ้งโอนเงิน</td></tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </>
            );
          })()}

          {/* ── Provinces ── */}
          {page === "provinces" && (() => {
            // สร้าง map จังหวัด → จำนวนคน (ใช้ lastSeenProvince ถ้ามี = ตำแหน่งจริงล่าสุด)
            const provMap = {};
            users.forEach((u) => {
              const p = u.lastSeenProvince || u.province || "ไม่ระบุ";
              provMap[p] = (provMap[p] || 0) + 1;
            });
            const provList = Object.entries(provMap).sort((a, b) => b[1] - a[1]);
            const total      = users.length || 1;
            const maxCount   = provList[0]?.[1] || 1;
            const withProv   = users.filter((u) => u.province).length;
            const withoutProv= users.length - withProv;

            // คนที่แสดงใน panel ด้านล่าง
            const panelUsers = selectedProvince === "__all__"
              ? users
              : users.filter((u) => (u.lastSeenProvince || u.province || "ไม่ระบุ") === selectedProvince);

            // นับดีลต่อ user
            const userDealCount = {};
            deals.forEach((d) => {
              [d.buyerId, d.sellerId].filter(Boolean).forEach((uid) => {
                userDealCount[uid] = (userDealCount[uid] || 0) + 1;
              });
            });

            const panelLabel = selectedProvince === "__all__"
              ? `ผู้ใช้ทั้งหมด (${users.length} คน)`
              : `${selectedProvince} (${panelUsers.length} คน)`;

            return (
              <>
                {/* ── 4 summary cards ── */}
                <div className="stats-grid" style={{ marginBottom: 20 }}>
                  <div className="stat-card">
                    <div className="stat-label">ผู้ใช้ทั้งหมด</div>
                    <div className="stat-num">{users.length}</div>
                    <div className="stat-change">ในระบบ</div>
                  </div>
                  <div className="stat-card info">
                    <div className="stat-label">ระบุจังหวัดแล้ว</div>
                    <div className="stat-num">{withProv}</div>
                    <div className="stat-change">{Math.round(withProv / total * 100)}% ของทั้งหมด</div>
                  </div>
                  <div className="stat-card warning">
                    <div className="stat-label">ยังไม่ระบุจังหวัด</div>
                    <div className="stat-num">{withoutProv}</div>
                    <div className="stat-change">รอ login ครั้งแรก</div>
                  </div>
                  <div className="stat-card">
                    <div className="stat-label">จังหวัดที่พบ</div>
                    <div className="stat-num">{provList.filter(([p]) => p !== "ไม่ระบุ").length}</div>
                    <div className="stat-change">จาก 77 จังหวัด</div>
                  </div>
                </div>

                {/* ── Province cards — คลิกเพื่อกรอง ── */}
                <div style={{ fontSize: "0.72rem", color: "#8a919e", marginBottom: 8, letterSpacing: 1 }}>
                  เลือกจังหวัดเพื่อดูรายชื่อผู้ใช้
                </div>
                <div className="prov-cards">
                  {/* ปุ่มทั้งหมด */}
                  <div
                    className={`prov-card all-btn${selectedProvince === "__all__" ? " selected" : ""}`}
                    onClick={() => setSelectedProvince("__all__")}
                  >
                    <div className="prov-card-name" style={{ color: "#8a919e" }}>ทั้งหมด</div>
                    <div className="prov-card-count">{users.length}</div>
                    <div className="prov-card-pct">100% ของทั้งหมด</div>
                    <div className="prov-mini-bar">
                      <div className="prov-mini-fill" style={{ width: "100%" }} />
                    </div>
                  </div>

                  {/* การ์ดแต่ละจังหวัด */}
                  {provList.map(([prov, cnt], i) => {
                    const medal = i < 3 ? `#${i + 1}` : "";
                    return (
                      <div
                        key={prov}
                        className={`prov-card${selectedProvince === prov ? " selected" : ""}`}
                        onClick={() => setSelectedProvince(prov)}
                      >
                        <div className="prov-card-name" title={prov}>
                          {medal} {prov}
                        </div>
                        <div className="prov-card-count">{cnt}</div>
                        <div className="prov-card-pct">{Math.round(cnt / total * 100)}% ของทั้งหมด</div>
                        <div className="prov-mini-bar">
                          <div className="prov-mini-fill"
                            style={{ width: `${Math.round(cnt / maxCount * 100)}%` }} />
                        </div>
                      </div>
                    );
                  })}

                  {provList.length === 0 && (
                    <div style={{ gridColumn: "1/-1", color: "#8a919e", textAlign: "center", padding: "32px 0", fontSize: "0.85rem" }}>
                      ยังไม่มีข้อมูลจังหวัด — ข้อมูลจะปรากฏเมื่อผู้ใช้เข้าสู่ระบบ
                    </div>
                  )}
                </div>

                {/* ── User panel — รายชื่อคนในจังหวัดที่เลือก ── */}
                <div className="prov-user-panel">
                  <div className="prov-panel-header">
                    <div>
                      <div className="prov-panel-title">{panelLabel}</div>
                      <div className="prov-panel-sub">
                        {selectedProvince === "__all__"
                          ? "แสดงผู้ใช้ทั้งหมดในระบบ"
                          : `คลิกจังหวัดอื่นเพื่อเปลี่ยนหรือกด "ทั้งหมด" เพื่อดูทุกคน`}
                      </div>
                    </div>
                    {selectedProvince !== "__all__" && (
                      <button
                        className="t-action"
                        onClick={() => setSelectedProvince("__all__")}
                      >
                        ✕ ล้างตัวกรอง
                      </button>
                    )}
                  </div>

                  {panelUsers.length === 0 ? (
                    <div style={{ color: "#8a919e", textAlign: "center", padding: "28px 20px", fontSize: "0.85rem" }}>
                      ไม่พบผู้ใช้ในจังหวัดนี้
                    </div>
                  ) : (
                    panelUsers.map((u) => {
                      const displayName = u.name || u.displayName || u.email?.split("@")[0] || "ไม่ระบุ";
                      const dealCnt     = userDealCount[u.id] || 0;
                      const joinDate    = u.createdAt?.toDate
                        ? u.createdAt.toDate().toLocaleDateString("th-TH", { day: "numeric", month: "short", year: "2-digit" })
                        : "-";
                      return (
                        <div className="prov-user-row" key={u.id}>
                          <div className="prov-avatar">
                            {displayName[0]?.toUpperCase()}
                          </div>
                          <div className="prov-user-info">
                            <div className="prov-user-name">{displayName}</div>
                            <div className="prov-user-email">{u.email || "-"}</div>
                            <div style={{display:"flex",alignItems:"center",gap:5,marginTop:3}}>
                              <span style={{fontSize:"0.68rem",color:"#88919e"}}>
                                {u.lastSeenProvince || u.province || "ไม่ระบุ"}
                              </span>
                              {u.lastSeenProvince
                                ? <span style={{fontSize:"0.58rem",background:"rgba(247,71,53,0.1)",color:"#dc3728",padding:"1px 6px",borderRadius:100,border:"1px solid rgba(247,71,53,0.2)"}}>auto</span>
                                : u.manualProvince
                                  ? <span style={{fontSize:"0.58rem",background:"rgba(85,153,255,0.1)",color:"#5599ff",padding:"1px 6px",borderRadius:100,border:"1px solid rgba(85,153,255,0.2)"}}>ตั้งเอง</span>
                                  : null}
                              {u.lastSeenAt && (
                                <span style={{fontSize:"0.62rem",color:"#a0a7b3"}}>
                                  · {(() => {
                                    const d = u.lastSeenAt?.toDate ? u.lastSeenAt.toDate() : new Date(u.lastSeenAt);
                                    const diff = Math.floor((Date.now() - d) / 60000);
                                    if (diff < 1) return "เพิ่งนี้";
                                    if (diff < 60) return `${diff} นาทีที่แล้ว`;
                                    if (diff < 1440) return `${Math.floor(diff/60)} ชม.ที่แล้ว`;
                                    return `${Math.floor(diff/1440)} วันที่แล้ว`;
                                  })()}
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="prov-user-meta">
                            <div className="prov-wallet">
                              ฿{(u.wallet_balance || 0).toLocaleString()}
                            </div>
                            <div className="prov-deals">{dealCnt} ดีล · เข้าร่วม {joinDate}</div>
                          </div>
                        </div>
                      );
                    })
                  )}
                </div>
              </>
            );
          })()}

          {/* ── Support Chat ── */}
          {page === "support" && (() => {
            return (
              <div className="sp-wrap">
                {/* Left: conversation list */}
                <div className="sp-list">
                  <div style={{ padding:"12px 16px", borderBottom:"1px solid rgba(247,71,53,0.1)", fontSize:"0.78rem", color:"#8a919e", letterSpacing:1 }}>
                    การสนทนา ({supportChats.length})
                  </div>
                  {supportChats.length === 0 && (
                    <div style={{ padding:20, color:"#a0a7b3", fontSize:"0.8rem", textAlign:"center" }}>ยังไม่มีการสนทนา</div>
                  )}
                  {supportChats.map(chat => (
                    <div key={chat.id}
                      className={`sp-conv-item${activeChatUid === chat.id ? " active" : ""}`}
                      onClick={() => setActiveChatUid(chat.id)}>
                      <div className="sp-conv-av">{(chat.userName || "U").charAt(0).toUpperCase()}</div>
                      <div className="sp-conv-info">
                        <div className="sp-conv-name">
                          {chat.userName || chat.userEmail || chat.id}
                          {(unreadByChat[chat.id] || 0) > 0 && chat.id !== activeChatUid && <span className="sp-conv-badge">{unreadByChat[chat.id]}</span>}
                        </div>
                        <div className="sp-conv-last">{chat.lastMsg || "—"}</div>
                      </div>
                    </div>
                  ))}
                </div>

                {/* Right: chat window — hidden on mobile when no chat selected */}
                <div className="sp-chat" style={{}}>
                  {!activeChatUid ? (
                    <div style={{ flex:1, display:"flex", alignItems:"center", justifyContent:"center", color:"#a0a7b3", fontSize:"0.85rem" }}>
                      เลือกการสนทนาจากรายการด้านซ้าย
                    </div>
                  ) : (() => {
                    const activeChat = supportChats.find(c => c.id === activeChatUid);
                    return (
                      <>
                        {/* header */}
                        <div className="sp-chat-head" style={{ display:"flex", alignItems:"center", gap:10 }}>
                          <button className="sp-back-btn" onClick={() => setActiveChatUid(null)}>← กลับ</button>
                          <div className="sp-conv-av" style={{ width:32, height:32, fontSize:"0.9rem" }}>
                            {(activeChat?.userName || "U").charAt(0).toUpperCase()}
                          </div>
                          <div>
                            <div style={{ fontWeight:700, fontSize:"0.88rem", color:"#242b36" }}>
                              {activeChat?.userName || activeChat?.id}
                            </div>
                            <div style={{ fontSize:"0.68rem", color:"#8a919e" }}>{activeChat?.userEmail || ""}</div>
                          </div>
                        </div>

                        {/* messages */}
                        <div className="sp-msgs" ref={supportMsgsRef}>
                          {chatMsgs.length === 0 && (
                            <div style={{ textAlign:"center", color:"#a0a7b3", fontSize:"0.78rem", padding:20 }}>ยังไม่มีข้อความ</div>
                          )}
                          {chatMsgs.map(m => (
                            <div key={m.id} className={`sp-msg ${m.isAdmin ? "admin" : "user"}`}>
                              {m.isAdmin && <div style={{ fontSize:"0.6rem", color:"#dc3728", marginBottom:2 }}>Admin</div>}
                              <div>{m.text}</div>
                              <div style={{ fontSize:"0.6rem", color:"#a0a7b3", marginTop:3 }}>
                                {m.createdAt?.toDate ? m.createdAt.toDate().toLocaleTimeString("th-TH", { hour:"2-digit", minute:"2-digit" }) : ""}
                              </div>
                            </div>
                          ))}
                        </div>

                        {/* input */}
                        <div className="sp-inputbar">
                          <textarea
                            className="sp-textarea"
                            rows={1}
                            placeholder="พิมพ์ข้อความตอบกลับ..."
                            value={replyInput}
                            onChange={e => setReplyInput(e.target.value)}
                            onKeyDown={e => { if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); sendAdminReply(); }}}
                          />
                          <button className="sp-sendbtn" onClick={sendAdminReply} disabled={!replyInput.trim() || replySending}>
                            {replySending ? "..." : <Icon name="send" size={16} />}
                          </button>
                        </div>
                      </>
                    );
                  })()}
                </div>
              </div>
            );
          })()}

        </div>
      </div>

      {/* ── Confirm Modal ── */}
      {confirmModal && (
        <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.7)", zIndex:10000, display:"flex", alignItems:"center", justifyContent:"center", padding:20 }}>
          <div style={{ background:"#f4f5f7", border:"1px solid rgba(247,71,53,0.2)", borderRadius:16, padding:28, maxWidth:360, width:"100%", textAlign:"center" }}>
            <div style={{ fontSize:"1rem", color:"#242b36", marginBottom:24, lineHeight:1.6 }}>{confirmModal.message}</div>
            <div style={{ display:"flex", gap:12, justifyContent:"center" }}>
              <button onClick={() => setConfirmModal(null)}
                style={{ flex:1, padding:"10px 0", borderRadius:8, border:"1px solid rgba(255,255,255,0.15)", background:"transparent", color:"#8a919e", fontFamily:"Prompt,sans-serif", fontSize:"0.88rem", cursor:"pointer" }}>
                ยกเลิก
              </button>
              <button onClick={async () => { setConfirmModal(null); await confirmModal.onConfirm(); }}
                style={{ flex:1, padding:"10px 0", borderRadius:8, border:"none", background:"#dc3728", color:"#f5f6f8", fontFamily:"Prompt,sans-serif", fontSize:"0.88rem", fontWeight:700, cursor:"pointer" }}>
                ยืนยัน
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ── Slip Image Modal ── */}
      {slipModal && (
        <div onClick={() => setSlipModal(null)}
          style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.85)", zIndex:9999, display:"flex", alignItems:"center", justifyContent:"center", padding:20, cursor:"zoom-out" }}>
          <div onClick={e => e.stopPropagation()}
            style={{ position:"relative", maxWidth:"90vw", maxHeight:"90vh" }}>
            <img src={slipModal} alt="slip"
              style={{ maxWidth:"100%", maxHeight:"85vh", borderRadius:12, display:"block", boxShadow:"0 8px 40px rgba(0,0,0,0.6)" }} />
            <button onClick={() => setSlipModal(null)}
              style={{ position:"absolute", top:-14, right:-14, width:32, height:32, borderRadius:"50%", border:"none", background:"#ff5555", color:"#fff", fontSize:"1rem", cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center", fontWeight:700 }}>
              ✕
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
